// Wisedrive Translations - English (EN) and Bahasa Malaysia (BM)
import { Calendar, FileSearch, FileCheck, Shield, Users, Star, Clock } from 'lucide-react';

const translations = {
  en: {
    // Navigation
    nav: {
      products: 'Products',
      howItWorks: 'How It Works',
      technology: 'Technology',
      aboutUs: 'About Us',
      forBusinesses: 'For Businesses',
      getStarted: 'WhatsApp Us',
      selectRegion: 'Select Region',
      selectLanguage: 'Language',
    },

    // B2B Banner
    b2bBanner: {
      text: 'Are you a Bank, Insurer, or Auction Platform?',
      cta: 'Explore Enterprise Solutions',
    },

    // Hero Section
    hero: {
      badge: "India's #1 Used Car Inspection Platform",
      badgeMY: "Malaysia's #1 Used Car Inspection Platform",
      headline1: 'No More Cheating.',
      headline2: 'Buy with Full Confidence.',
      subheadline: 'Used Car Shopping?',
      subheadlineSuffix: "We've Got Your Back.",
      description: 'Every year, {count} lose money on problematic used cars. Our {inspection} exposes every hidden defect — odometer fraud, accident damage, engine issues — before you pay a single rupee.',
      descriptionMY: 'Every year, {count} lose money on problematic used cars. Our {inspection} exposes every hidden defect — odometer fraud, accident damage, engine issues — before you pay a single ringgit.',
      lakhsOfIndians: 'lakhs of Indians',
      thousandsOfMalaysians: 'thousands of Malaysians',
      aiInspection: '200+ point AI inspection',
      bookInspection: 'Book Inspection',
      viewSampleReport: 'View Sample Report',
      avgNegotiated: 'Average price negotiated down',
      worthEveryRupee: 'Worth Every Rupee',
      worthEveryRinggit: 'Worth Every Ringgit',
      catchTitle: 'We Catch What Others Miss:',
      odometerTampering: 'Odometer Tampering',
      hiddenAccident: 'Hidden Accident Damage',
      floodDamaged: 'Flood Damaged Cars',
      fakeDocs: 'Fake Documents & Blacklist',
      checkPoints: 'Check Points',
      aiPowered: 'AI-Powered',
      moreAccurate: '20x more accurate',
    },
    //step process section (From booking to buying)
    howItWorks: {
      steps: [
        {
          icon: Calendar,
          number: '01',
          title: 'Book in 60 Seconds',
          description: 'Schedule an inspection at your preferred time and location. Our expert will come to you.',
          highlight: 'Free cancellation',
        },
        {
          icon: FileSearch,
          number: '02',
          title: 'Expert Inspection',
          description: 'Our certified mechanic performs a comprehensive 200+ point AI-assisted inspection.',
          highlight: '2-3 hours',
        },
        {
          icon: FileCheck,
          number: '03',
          title: 'Get Digital Report',
          description: 'Receive a detailed report with AI rating, photos, and market value estimation.',
          highlight: 'Instant delivery',
        },
        {
          icon: Shield,
          number: '04',
          title: 'Buy with Protection',
          description: 'Get warranty coverage and financing options based on your car\'s inspection score.',
          highlight: 'Warranty eligible',
        },
      ],
      subTitle: 'Simple 4-Step Process',
      title: 'From Booking to Buying',
      description: 'No uncertainty. Know exactly what you\'re buying.',

    },
    // Services Section
    services: {
      badge: 'Complete Car Ownership Solution',
      headline1: 'Everything You Need,',
      headline2: 'Under One Roof',
      description: "From inspection to warranty to financing — we've got your used car journey covered.",

      // Inspection Card
      inspection: {
        title: 'AI Car Inspection',
        startingFrom: 'Starting from',
        description: '200+ point AI-powered inspection that catches what others miss',
        features: ['AI-Powered Analysis', 'Digital Report in 3 Hrs', 'OBD2 Diagnostics', 'RTO Verification'],
        featuresMY: ['AI-Powered Analysis', 'Digital Report in 3 Hrs', 'OBD2 Diagnostics', 'JPJ Verification'],
        bookBtn: 'Book Inspection',
      },

      // Warranty Card
      warranty: {
        title: 'Extended Warranty',
        mostPopular: 'MOST POPULAR',
        description: 'Showroom-grade protection with 98% claim approval rate',
        features: ['OEM Workshop Network', '90% Claim Payout', 'Roadside Assistance', 'Pan-India Coverage'],
        featuresMY: ['OEM Workshop Network', '90% Claim Payout', 'Roadside Assistance', 'Nationwide Coverage'],
        buyBtn: 'Buy Warranty',
        fileClaim: 'File a Claim',
      },

      // Financing Card
      financing: {
        title: 'Car Financing',
        interestFrom: 'Interest from',
        description: 'Compare offers from 15+ banks and get instant approval',
        features: ['15+ Bank Partners', 'Instant Approval', '100% Digital Process', 'Lowest EMI Options'],
        compareBtn: 'Compare Loans',
      },

      // Doorstep Car Service Card — opens internal modal (mirrors /carservice LP UX in-modal)
      carservice: {
        title: 'Doorstep Car Service',
        startingFrom: 'Starting from',
        description: 'Premium doorstep service with OEM parts. Service in 1 hour, 1,000 km warranty.',
        features: ['Doorstep Pickup & Drop', 'OEM Parts Only', 'Service in 1 Hr', '1,000 Km Warranty'],
        bookBtn: 'Book Service',
        whatsappBtn: 'Chat on WhatsApp',
      },
      bottomStats: [{ icon: Users, value: '50,000+', label: 'Cars Inspected' }, { icon: Star, value: '4.8/5', label: 'Customer Rating' }, { icon: Clock, value: '< 3 Hrs', label: 'Report Delivery' }, { icon: Shield, value: '98%', label: 'Claim Approval' }],
      // Stats
      stats: {
        carsInspected: 'Cars Inspected',
        customerRating: 'Customer Rating',
        reportDelivery: 'Report Delivery',
        claimApproval: 'Claim Approval',
      },
    },

    // Inspection Modal
    inspectionModal: {
      title: 'Book Car Inspection',
      subtitle: '200+ Check Points • Report in 2-3 Hours',
      selectPlan: 'Select Plan',
      yourDetails: 'Your Details',
      verifyOtp: 'Verify OTP',
      vehicleInfo: 'Vehicle Info',
      schedule: 'Schedule',
      payment: 'Payment',

      inspectionSteps: [
        { num: 1, label: 'Select Plan' },
        { num: 2, label: 'Your Details' },
        { num: 3, label: 'Verify OTP' },
        { num: 4, label: 'Vehicle Info' },
        { num: 5, label: 'Schedule' },
        { num: 6, label: 'Payment' },
      ],
      // Step 1
      choosePlan: 'Choose Your Inspection Package',
      standard: 'Standard',
      luxury: 'Luxury',
      forBudgetCars: 'For Budget Cars',
      forPremiumCars: 'For Premium Cars',
      recommended: 'RECOMMENDED',
      checkPoints: 'Check Points',
      inclTaxes: 'incl. taxes',
      continueWith: 'Continue with',
      package: 'Package',
      brands: 'Brands',
      regPlaceholder: 'e.g., KA48N1000',
      luxuryAddons: '+ OBD2 + RTO',
      inspectionCategories: [
        {
          id: 'physical',
          title: 'Physical / Manual Inspection',
          points: 135,
          icon: 'car',
          items: ['Engine & Transmission Check', 'Electrical Parts Check', 'Mechanical Parts Check', 'Interior & Exterior Check'],
          benefits: ['Flood Vehicle Check', 'Major Engine Repair Check', 'Battery Function Check', 'Odometer Tampering Check', 'Braking System Check', 'Fuel System Check'],
          includedIn: ['standard', 'luxury']
        },
        {
          id: 'obd2',
          title: 'Advanced OBD2 Scanner Test',
          points: 76,
          icon: 'scan',
          items: ['Engine Control Module (ECM)', 'Transmission Control Module', 'Body Control Module (BCM)', 'Fault Code Check & Analysis'],
          benefits: ['Engine Failure Probability Analysis', 'Transmission Failure Probability', 'High Speed Stability Check', 'Expensive Repair Prevention Check'],
          includedIn: ['luxury']
        },
        {
          id: 'rto',
          title: 'RTO & Police Verification',
          points: 29,
          icon: 'shield',
          items: ['Loan & Insurance Check', 'Traffic Fines & Blacklist Check', 'PUC & RC Validity Check', 'Owners & Vehicle Info Check'],
          benefits: ['Loan NOC Check', 'Insurance Expiry Check', 'Blacklist Status Check', 'Vaahan Database Verification'],
          includedIn: ['luxury']
        },
        {
          id: 'support',
          title: 'Additional Technical Support',
          points: 'FREE',
          icon: 'headphones',
          items: ['Fair Price Estimate', 'Repair Estimate', 'Expert Mechanic Advice', 'Extended Warranty (up to 2 years)'],
          benefits: [],
          includedIn: ['standard', 'luxury']
        }
      ],
      // Inspection Categories
      inspectionCoverage: 'Check Points Inspection Coverage',
      physicalInspection: 'Physical / Manual Inspection',
      obd2Scanner: 'Advanced OBD2 Scanner Test',
      rtoVerification: 'RTO & Police Verification',
      jpjVerification: 'JPJ & Police Verification',
      technicalSupport: 'Additional Technical Support',
      luxuryOnly: 'LUXURY',
      additionalBenefits: 'Additional Benefits:',
      upgradePrompt: 'Upgrade to Luxury ',
      upgradePrompt1: 'for OBD2 Scanner Test & RTO Verification',
      extraCheckpoints: 'extra checkpoints',

      continueWith: 'Continue with',
      selected: 'Selected',


      // Step 2
      unlocking: 'Unlocking',
      inspection: 'Inspection',
      registerMobile: 'Register With Mobile Number',
      sendOtpDesc: "We'll send an OTP to verify your number",
      fullName: 'Full Name',
      enterFullName: 'Enter your full name',
      mobileNumber: 'Mobile Number',
      digitMobile: '10-digit mobile number',
      back: 'Back',
      sendOtp: 'Send OTP',

      // Step 3 - OTP
      verifyOtpTitle: 'Verify OTP',
      enterCode: 'Enter 6-digit code sent to',
      resendIn: 'Resend OTP in',
      resendOtp: 'Resend OTP',
      changeNumber: 'Change Number',
      verifyOtpBtn: 'Verify OTP',
      didntReceive: "Didn't receive? Check SMS inbox or spam folder.",

      // Step 4 - Vehicle
      mobileVerified: 'Mobile Verified!',
      enterRegNumber: 'Enter your car registration number to auto-fetch details',
      regNumber: 'Registration Number',
      vehicleFound: 'Vehicle Found!',
      makeModel: 'Make & Model',
      fuelType: 'Fuel Type',
      color: 'Color',
      regDate: 'Reg. Date',
      rto: 'RTO',
      change: 'Change',
      confirm: 'Confirm',
      skipEnterManually: 'Skip & Enter Details Manually',

      // Step 5 - Schedule
      selectCity: 'Select Your City',
      orTypeCity: 'Or type your city...',
      pickDate: 'Pick a Date',
      chooseTime: 'Choose Time Slot',
      emailOptional: 'Email (Optional - for detailed report)',
      emailPlaceholder: 'your@email.com',
      yourSelection: 'Your Selection',
      proceedPayment: 'Proceed to Payment',
      carBrand: 'Car Brand',
      carBrandPlaceholder: 'e.g., Maruti',
      carModel: 'Car Model',
      carModelPlaceholder: 'e.g., Swift',
      locationLabel: 'Location',
      dateLabel: 'Date',
      timeLabel: 'Time',
      paid: 'PAID',
      inspectionLabel: 'Inspection',

      // Step 6 - Payment
      orderSummary: 'Order Summary',
      secure: 'SECURE',
      checkpointInspection: 'Checkpoint Inspection',
      whatsIncluded: "What's Included",
      physicalInsp: 'Physical Inspection',
      obd2Test: 'OBD2 Scanner Test',
      digitalReport: 'Digital Report',
      fairPriceEst: 'Fair Price Estimate',
      expertAdvice: 'Expert Advice',
      trustIndicators: {
        secure: '100% Secure',
        encrypted: 'Encrypted Payment',
        reschedule: 'Free Reschedule',
        upTo24hrs: 'Upto 24hrs Before',
        rating: 'Rating',
        reviews: 'Reviews',
      },
      selectPayment: 'Select Payment Method',
      upi: 'UPI',
      upiDesc: 'GPay, PhonePe, Paytm',
      card: 'Card',
      cardDesc: 'Credit/Debit',
      netBanking: 'Net Banking',
      allBanks: 'All Banks',
      inspectionFee: 'Inspection Fee',
      taxesIncluded: 'Taxes (Included)',
      totalAmount: 'Total Amount',
      moneyBack: '100% Money Back Guarantee',
      moneyBackDesc: "Full refund if inspector doesn't arrive on time",
      pay: 'Pay',
      securedBy: 'Secured by trusted payment partners',
      razorpay: 'Razorpay',
      visa: 'Visa',
      mastercard: 'Mastercard',
      upi: 'UPI',

      // Step 7 - Confirmation
      bookingConfirmed: 'Booking Confirmed!',
      inspectorAssigned: "Your inspection is scheduled. We're assigning the best inspector for your car.",
      bookingDetails: 'Booking Details',
      bookingId: 'Booking ID',
      inspectionDate: 'Inspection Date',
      timeSlot: 'Time Slot',
      packageLabel: 'Package',
      carLabel: 'Car',
      amountPaid: 'Amount Paid',
      whatNext: "What's Next?",
      steps: {
        confirmation: { title: 'Confirmation', desc: 'SMS & WhatsApp sent', time: 'Done' },
        assignment: { title: 'Inspector Assignment', desc: 'Within 2 hours', time: '2 hrs' },
        inspection: { title: 'On-site Inspection', desc: 'At your location', time: 'Scheduled' },
        report: { title: 'Digital Report', desc: 'With AI analysis', time: '2-3 hrs' },
      },
      needReschedule: 'Need to reschedule?',
      freeChanges: 'Free changes up to 24hrs before',
      callSupport: 'Call Support',
      confirmationSent: 'Confirmation sent to',
      close: 'Close',
      bookAnother: 'Book Another Inspection',
    },

    // Warranty Modal
    warrantyModal: {
      title: 'Extended Car Warranty',
      subtitle: '98% Claim Approval • OEM Workshops',
      selectPlan: 'Select Plan',
      yourDetails: 'Your Details',
      verifyOtp: 'Verify OTP',
      confirmation: 'Confirmation',
      warrantySteps: [
        { num: 1, label: 'Select Plan' },
        { num: 2, label: 'Your Details' },
        { num: 3, label: 'Verify OTP' },
        { num: 4, label: 'Confirmation' },
      ],

      // Step 1
      choosePlan: 'Choose Your Warranty Plan',
      quarterly: 'Quarterly',
      sixMonths: '6 Months',
      annual: 'Annual',
      perQuarter: 'per quarter',
      forSixMonths: 'for 6 months',
      perYear: 'per year',
      bestValue: 'BEST VALUE',
      coPay: 'Co-Pay',
      wePay: 'We Pay',
      continue: 'Continue',

      // Step 2
      unlockingWarranty: 'Unlocking',
      warranty: 'Warranty',

      // Step 4 - Confirmation
      requestSubmitted: 'Request Submitted!',
      teamWillContact: 'Our Team Will Contact You Shortly',
      expertWillCall: 'A Wisedrive warranty expert will call you within {hours} to discuss your {plan} plan and complete the enrollment.',
      twoToFourHours: '2-4 hours',
      name: 'Name',
      phone: 'Phone',
      plan: 'Plan',
      amount: 'Amount',
      supportHours: 'Mon-Sat, 9AM-7PM',
      supportPhone: 'Support',
      supportNumber: '99051 29146',
      done: 'Done',
      warrantyPackages: [
        { id: 'quarterly', name: 'Quarterly', price: 1499, period: 'per quarter', duration: '3 Months', coPay: '20%', payout: '80%', features: ['Engine & Transmission', 'Electrical Parts', 'Mechanical Parts', 'AC Warranty', 'Roadside Assistance'] },
        { id: 'halfyearly', name: '6 Months', price: 2999, period: 'for 6 months', duration: '6 Months', coPay: '10%', payout: '90%', recommended: true, features: ['Engine & Transmission', 'Electrical Parts', 'Mechanical Parts', 'AC Warranty', 'Roadside Assistance', 'Pan-India Coverage'] },
        { id: 'yearly', name: 'Annual', price: 4999, period: 'per year', duration: '12 Months', coPay: '10%', payout: '90%', features: ['Engine & Transmission', 'Electrical Parts', 'Mechanical Parts', 'AC Warranty', 'Roadside Assistance', 'Pan-India Coverage', '24/7 Support', 'OEM Workshops'] }
      ]
    },

    // Claim Modal
    claimModal: {
      title: 'File Warranty Claim',
      subtitle: '98% Approval • 24hr Processing',
      howItWorks: 'How Claim Process Works',
      steps: {
        submit: { title: 'Submit Claim', desc: 'Fill claim form' },
        upload: { title: 'Upload Photos', desc: 'Attach photos (optional)' },
        review: { title: 'We Review', desc: 'Review in 24 hours' },
        repair: { title: 'Get Repaired', desc: 'Visit OEM workshop' },
      },
      startProcess: 'Start Claim Process',
      warrantyId: 'Warranty ID / Policy Number',
      selectClaimType: 'Select Claim Type',
      claimTypes: {
        engine: 'Engine Issue',
        transmission: 'Transmission Issue',
        electrical: 'Electrical Problem',
        ac: 'AC / Cooling Issue',
        mechanical: 'Mechanical Parts',
      },
      describeIssue: 'Describe the issue',
      submitClaim: 'Submit Claim',
      claimSubmitted: 'Claim Submitted!',
      contactWithin24: "We'll contact you within 24 hours.",
    },

    // Trust Section
    trust: {
      claimRate: 'Claim Rate',
      inspected: 'Inspected',
      satisfaction: 'Satisfaction',
      avgSaved: 'Avg. Saved',
      whyChooseUs: 'Why Choose Us',
      smartestInvestment: 'The Smartest Investment Before Your Car',
      inspectionCanSave: 'A {price} inspection can save you from a {bigPrice}+ mistake.',
      reasons: {
        catchProblems: { title: 'Catch Hidden Problems', desc: 'Our 200+ point check reveals issues worth {range} in repairs' },
        oemWorkshop: { title: 'OEM Workshop Network', desc: 'Direct partnerships with authorized service centers' },
        reportHours: { title: 'Report in Hours', desc: 'Get comprehensive digital report same day' },
        negotiation: { title: 'Negotiation Power', desc: 'Average {amount} saved with our detailed reports' },
      },
      testimonial: 'Found transmission issues saving me {amount} in repairs.',
      testimonialAuthor: 'Rahul M., Mumbai',
      testimonialAuthorMY: 'Ahmad R., Kuala Lumpur',
    },

    // AI Technology Section
    aiTech: {
      poweredBy: 'Powered by Generative AI',
      headline: "Don't Trust Your Eyes.",
      headlinePart2: 'Trust Our AI.',
      description: 'Fraudsters are getting smarter. Our AI is smarter. Trained on {count}+ real inspections, we catch what even expert mechanics miss.',
      trainingData: 'Training Data Points',
      checkpoints: 'Inspection Checkpoints',
      reportDelivery: 'Report Delivery',
      customerSavings: 'Avg. Customer Savings',
      problemsTitle: 'Problems Our AI Catches',
      problemsSubtitle: '(That Others Miss)',
      problems: {
        odometer: { title: 'Tampered Odometer', desc: 'AI detects mileage fraud with 99.7% accuracy' },
        accidents: { title: 'Hidden Accidents', desc: 'Computer vision spots repainted panels & repairs' },
        engine: { title: 'Engine Issues', desc: 'OBD2 scans reveal hidden fault codes' },
        flood: { title: 'Flood Damage', desc: 'Sensors detect water damage in electronics' },
      },
      techEdge: 'Our Technology Edge',
      capabilities: {
        vision: { stat: '20x', highlight: 'More Accurate', title: 'Computer Vision', desc: 'Detects paint thickness variations, panel gaps, and body repairs invisible to naked eye' },
        ai: { stat: '99.7%', highlight: 'Fraud Detection', title: 'Deep Learning AI', desc: 'Trained on {count}+ inspections to identify odometer tampering and fake documents' },
        obd: { stat: '76+', highlight: 'ECU Parameters', title: 'OBD2 Diagnostics', desc: 'Reads engine, transmission, ABS & airbag codes that mechanics often miss' },
        predictive: { stat: '12-24', highlight: 'Months Ahead', title: 'Predictive Analysis', desc: 'Forecasts potential failures based on wear patterns and historical data' },
      },
      categories: 'Points Across 4 Critical Categories',
      categoryItems: {
        exterior: { name: 'Exterior & Body', items: ['Paint Condition', 'Panel Gaps', 'Rust Check', 'Glass & Lights'] },
        engine: { name: 'Engine & Mechanical', items: ['Oil Quality', 'Belts & Hoses', 'Fluid Levels', 'Exhaust System'] },
        electronics: { name: 'Electronics & OBD', items: ['ECU Scan', 'Fault Codes', 'Sensor Health', 'Battery Test'] },
        documents: { name: 'Documents & Legal', items: ['RC Verification', 'Insurance Status', 'Loan Check', 'Blacklist Scan'] },
        documentsMY: { name: 'Documents & Legal', items: ['Grant Verification', 'Insurance Status', 'Loan Check', 'Blacklist Scan'] },
      },
      aiGuarantee: 'Every inspection backed by our',
      aiAccuracyGuarantee: 'AI Accuracy Guarantee',
    },

    // Financial Services
    finance: {
      badge: 'Loans Processed',
      badgeAmount: '500 Cr+',
      badgeAmountMY: '250M+',
      headline: 'Finance Your Dream Car at',
      headlineHighlight: 'Best Rates',
      description: "Compare instant loan offers from India's top banks. Get pre-approved in minutes, not days. 100% transparent, zero hidden fees.",
      descriptionMY: "Compare instant loan offers from Malaysia's top banks. Get pre-approved in minutes, not days. 100% transparent, zero hidden fees.",
      stats: {
        bankPartners: { value: '15+', label: 'Bank Partners', sublabel: 'Top Banks & NBFCs' },
        quickApproval: { value: '24hrs', label: 'Quick Approval', sublabel: 'Same Day Disbursal' },
        startingRate: { value: '10.45%', label: 'Starting Rate', sublabel: 'Lowest in Market' },
        digitalProcess: { value: '100%', label: 'Digital Process', sublabel: 'Zero Paperwork' },
      },
      whyFinance: 'Why Finance with Wisedrive?',
      benefits: [
        'No hidden charges or processing fees',
        'Pre-approved offers from trusted partners',
        'Special rates for Wisedrive customers',
        'happy customers financed',
      ],
      trustedPartners: 'Trusted Banking Partners',

      // EMI Calculator
      emiCalculator: 'EMI Calculator',
      estimatePayment: 'Estimate your monthly payment',
      loanAmount: 'Loan Amount',
      loanTenure: 'Loan Tenure',
      months: 'Months',
      interestRate: 'Interest Rate',
      bestRate: 'Best Rate',
      monthlyEmi: 'Your Monthly EMI',
      totalPayable: 'Total Payable',
      compareOffers: 'Compare All Loan Offers',
      secureComparison: 'Secure & Instant Comparison',
    },

    // Benefits Section
    benefits: {
      why: 'Why Wisedrive',
      smartChoice: 'The Smart Choice for Used Cars',
      items: {
        check: { title: '200+ Point Check', stat: '20x', desc: 'more accurate' },
        report: { title: 'Instant Report', stat: '3hrs', desc: 'delivery time' },
        warranty: { title: 'Warranty Ready', stat: '<1.5%', desc: 'claim rate' },
        loans: { title: 'Best Loan Rates', stat: '15+', desc: 'bank partners' },
        digital: { title: '100% Digital', stat: '0', desc: 'paperwork' },
        support: { title: '24/7 Support', stat: '98%', desc: 'satisfaction' },
      },
      ctaTitle: 'Ready to Buy with Confidence?',
      ctaDesc: 'Book your inspection now and save an average of {amount} in negotiations',
    },
    // Comparison Section
    comparison: {
      badge: "Why We're Different",
      title: "Wisedrive vs Local Mechanics",
      subtitle: "Local inspections can't offer warranty protection. We don't just inspect – we {protect} your purchase.",
      protect: "protect your purchase",
      table: {
        feature: "Feature",
        wisedrive: "Wisedrive",
        local: "Local Mechanic",
      },
      features: {
        points: {
          title: "Inspection Points",
          wisedrive: "200+ AI-powered checkpoints",
          local: "20-30 basic checks",
        },
        warranty: {
          title: "Warranty Protection",
          wisedrive: "Up to 2 years coverage included",
          local: "No warranty offered",
        },
        report: {
          title: "Digital Report",
          wisedrive: "Detailed report with photos & AI rating",
          local: "Verbal feedback only",
        },
        fraud: {
          title: "Fraud Detection",
          wisedrive: "RTO & Police verification included",
          local: "Not available",
        },
        obd: {
          title: "OBD2 Diagnostics",
          wisedrive: "76 ECU parameters scanned",
          local: "Basic visual check only",
        },
        price: {
          title: "Price Transparency",
          wisedrive: "Fair market value estimate",
          local: "Biased towards seller",
        },
      },
      benefits: [
        { title: "Protected Purchase", desc: "Warranty coverage for peace of mind" },
        { title: "98% Claim Approval", desc: "Industry-leading claim rate" },
        { title: "OEM Workshops", desc: "Authorized service centers only" },
        { title: "24/7 Support", desc: "Round-the-clock assistance" },
      ],
      cta: "Don't settle for inspections without protection. {bold}",
      ctaBold: "Get warranty-backed confidence.",
    },
    // Warranty Showcase
    warrantyShowcase: {
      badge: "OEM Workshop Network",
      title: "Showroom-Grade Warranty",
      subtitle: "Get manufacturer-level protection for your used car. Partnered with authorized service centers of all major brands across India.",
      subtitleMY: "Get manufacturer-level protection for your used car. Partnered with authorized service centers of all major brands across Malaysia.",
      stats: {
        claimApproval: "Claim Approval",
        claimProcessing: "Claim Processing",
        serviceCenters: "Service Centers",
        deductible: "Deductible",
      },
      coverage: {
        engine: {
          title: "Engine & Transmission",
          desc: "Complete coverage for all engine and transmission components including automatic transmissions",
          highlight: "Full Coverage",
        },
        electrical: {
          title: "Electrical Systems",
          desc: "Wiring, battery, infotainment, lights, sensors, and all electronic components",
          highlight: "Full Coverage",
        },
        mechanical: {
          title: "Mechanical Parts",
          desc: "Suspension, shock absorbers, steering, braking system, and drivetrain",
          highlight: "Full Coverage",
        },
        cooling: {
          title: "AC & Cooling",
          desc: "Compressor, condenser, cooling system, and all climate control components",
          highlight: "Full Coverage",
        },
        roadside: {
          title: "Roadside Assistance",
          desc: "24/7 emergency support with towing, battery jump-start, and on-spot repairs",
          highlight: "Included Free",
        },
        network: {
          titleIndia: "Pan-India Network",
          titleMY: "Nationwide Network",
          descIndia: "Access to 7000+ authorized service centers across all major cities",
          descMY: "Access to 500+ authorized service centers across all major cities",
          highlightIndia: "7000+ Centers",
          highlightMY: "500+ Centers",
        },
      },
      banner: {
        badge: "Backed by Inspection",
        title: "Free Warranty with Every Inspection",
        desc: "Cars that pass our AI inspection automatically qualify for extended warranty coverage. No hidden terms, no surprises.",
        duration: "Up to 2 Years",
        durationLabel: "Coverage Duration",
        payout: "90%",
        payoutLabel: "We Pay on Claims",
        authorized: "Authorized",
      },
    },
    // Loan Comparison
    loanComparison: {
      title: "Compare Loan Offers",
      subtitle: "Get best rates from 15+ banks & NBFCs",
      loanDetails: "Loan Details",
      carValue: "Car Value",
      carValuePlaceholder: "e.g., 700000",
      loanAmount: "Loan Amount",
      loanAmountPlaceholder: "e.g., 500000",
      tenure: "Loan Tenure (Months)",
      tenureOptions: {
        12: "12 Months (1 Year)",
        24: "24 Months (2 Years)",
        36: "36 Months (3 Years)",
        48: "48 Months (4 Years)",
        60: "60 Months (5 Years)",
        72: "72 Months (6 Years)",
      },
      employmentType: "Employment Type",
      employmentOptions: {
        salaried: "Salaried",
        self_employed: "Self Employed",
      },
      compareBtn: "Compare Loan Offers",
      comparingBtn: "Comparing Offers...",
      bestOfferFound: "Best Offer Found!",
      bestOfferDesc: "{lender} offers the lowest EMI for your loan",
      bestOfferBadge: "BEST OFFER",
      monthlyEmi: "Monthly EMI",
      interestRate: "Interest Rate",
      processingFee: "Processing Fee",
      totalInterest: "Total Interest",
      totalPayable: "Total Payable",
      applyNow: "Apply Now",
      compareAgain: "Compare Again",
      errorTitle: "Error",
      errorDesc: "Failed to fetch loan offers. Please try again.",
    },

    // Testimonials Section
    testimonials: {
      badge: "Customer Stories",
      title: "What Our Customers Say",
      items: [
        {
          name: "Rajesh Kumar",
          location: "Mumbai, Maharashtra",
          car: "2018 Honda City",
          review: "Wisedrive made buying my used car stress-free. From inspection to financing, everything was transparent.",
          services: ["Inspection", "Warranty", "Financing"],
          rating: 5,
          image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
        },
        {
          name: "Priya Sharma",
          location: "Bangalore, Karnataka",
          car: "2019 Hyundai Creta",
          review: "As a first-time buyer, Wisedrive guided me through everything!",
          services: ["Inspection", "Warranty", "Financing"],
          rating: 4.8,
          image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
        },
        {
          name: "Amit Patel",
          location: "Ahmedabad, Gujarat",
          car: "2017 Maruti Swift",
          review: "The inspection alone was worth it. Saved me from a bad purchase!",
          services: ["Inspection", "Financing"],
          rating: 4.9,
          image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150"
        },
        {
          name: "Sneha Reddy",
          location: "Hyderabad, Telangana",
          car: "2020 Tata Nexon",
          review: "Wisedrive is a game-changer for used car buyers. Highly recommend!",
          services: ["Inspection", "Warranty", "Financing"],
          rating: 5,
          image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
        }
      ]
    },

    // FAQ Section
    faq: {
      badge: 'Got Questions?',
      title: 'Frequently Asked',
      titleHighlight: 'Questions',
      searchPlaceholder: 'Search for answers...',
      categories: {
        all: 'All',
        inspection: 'Inspection',
        warranty: 'Warranty',
        finance: 'Finance',
      },
      stillHaveQuestions: 'Still have questions?',
      cantFind: "Can't find what you're looking for? Our team is here to help.",
      callUs: 'Call Us',
      emailUs: 'Email Us',
      questions: [
        { q: 'What does the car inspection include?', a: 'Our comprehensive inspection covers 200+ checkpoints including engine, transmission, electrical systems, body condition, interior, documents verification (RC, insurance, loan status), and a detailed digital report with photos.' },
        { q: 'How long does the inspection take?', a: 'The on-site inspection takes about 45-60 minutes. You will receive the detailed digital report within 2-3 hours after the inspection is complete.' },
        { q: 'Can I get inspection at my location?', a: 'Yes! Our certified inspectors come to your preferred location - whether it is a dealership, seller\'s location, or your home. We cover 500+ cities across India.' },
        { q: 'What does the Wisedrive warranty cover?', a: 'Our warranty covers engine, transmission, electrical components, AC system, and mechanical parts. We have partnerships with OEM-authorized workshops across India for repairs.' },
        { q: 'How do I file a warranty claim?', a: 'Simply click the "File Claim" button, fill in the details about the issue, and our team will contact you within 24 hours. We have a 98% claim approval rate.' },
        { q: 'Which cars are eligible for warranty?', a: 'Cars that pass our inspection with a rating of 3.5/5 or above are eligible for our warranty plans. The inspection helps determine the warranty eligibility and pricing.' },
        { q: 'Can I get financing through Wisedrive?', a: 'Yes! We partner with 15+ banks and NBFCs to offer competitive car loan rates starting from 10.45% p.a. Compare multiple offers and get instant pre-approval.' },
        { q: 'What documents are needed for a car loan?', a: 'Basic documents include ID proof (Aadhaar/PAN), address proof, income proof (salary slips/ITR), and the car\'s RC. Our 100% digital process makes it hassle-free.' },
        { q: 'Is the service available in my city?', a: 'We operate in 500+ cities across India including all major metros and tier-2 cities. Enter your location while booking to confirm availability.' },
      ],
      questionsMY: [
        { q: 'What does the car inspection include?', a: 'Our comprehensive inspection covers 200+ checkpoints including engine, transmission, electrical systems, body condition, interior, documents verification (Grant, insurance, loan status), and a detailed digital report with photos.' },
        { q: 'How long does the inspection take?', a: 'The on-site inspection takes about 45-60 minutes. You will receive the detailed digital report within 2-3 hours after the inspection is complete.' },
        { q: 'Can I get inspection at my location?', a: 'Yes! Our certified inspectors come to your preferred location - whether it is a dealership, seller\'s location, or your home. We cover all major cities across Malaysia.' },
        { q: 'What does the Wisedrive warranty cover?', a: 'Our warranty covers engine, transmission, electrical components, AC system, and mechanical parts. We have partnerships with OEM-authorized workshops across Malaysia for repairs.' },
        { q: 'How do I file a warranty claim?', a: 'Simply click the "File Claim" button, fill in the details about the issue, and our team will contact you within 24 hours. We have a 98% claim approval rate.' },
        { q: 'Which cars are eligible for warranty?', a: 'Cars that pass our inspection with a rating of 3.5/5 or above are eligible for our warranty plans. The inspection helps determine the warranty eligibility and pricing.' },
        { q: 'Can I get financing through Wisedrive?', a: 'Yes! We partner with 15+ banks to offer competitive car loan rates starting from 3.5% p.a. Compare multiple offers and get instant pre-approval.' },
        { q: 'What documents are needed for a car loan?', a: 'Basic documents include MyKad, address proof, income proof (payslips/EA form), and the car\'s Grant. Our 100% digital process makes it hassle-free.' },
        { q: 'Is the service available in my city?', a: 'We operate in all major cities across Malaysia including Kuala Lumpur, Penang, Johor Bahru, and more. Enter your location while booking to confirm availability.' },
      ],
    },

    // Footer
    footer: {
      tagline: 'Making used car buying safe & transparent.',
      company: 'Company',
      about: 'About Us',
      careers: 'Careers',
      press: 'Press',
      contact: 'Contact',
      services: 'Services',
      inspection: 'Car Inspection',
      warranty: 'Extended Warranty',
      financing: 'Car Financing',
      forBusiness: 'For Business',
      support: 'Support',
      helpCenter: 'Help Center',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      refund: 'Refund Policy',
      copyright: 'All rights reserved.',
    },

    // Legal Pages
    legal: {
      backToHome: 'Back to Home',
      lastUpdated: 'Last Updated',
      effectiveDate: 'Effective Date',
      contactUs: 'Contact Us',
      privacy: {
        title: 'Privacy Policy',
        subtitle: 'How we collect, use, and protect your personal information.',
      },
      terms: {
        title: 'Terms of Service',
        subtitle: 'Terms and conditions governing the use of Wisedrive inspection services.',
        general: 'General',
        exclusions: 'Exclusions',
        exclusionsSubtitle: 'The items We do not check are:',
        inspectionCannot: 'Furthermore, the Inspection cannot:',
        roadTesting: 'Road Testing',
        feesAndCancellations: 'Fees and Cancellations',
        complaints: 'Complaints',
        outsideControl: 'Matters Outside of Our Reasonable Control',
        enforcement: 'Enforcement of Terms',
        reportAdvice: 'Report Advice',
      },
      refund: {
        titleIN: 'Cancellation and Refund Policy',
        titleMY: 'Cancellation & Refund Policy',
        subtitle: 'Our policies for cancellations and refunds.',
      },
    },

    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      yes: 'Yes',
      no: 'No',
      ok: 'OK',
      free: 'FREE',
      otpSent: 'OTP Sent!',
      otpSentDesc: 'OTP sent to {phone}',
      invalidOtp: 'Invalid OTP',
      verified: 'Verified!',
      verifiedDesc: 'Mobile number verified successfully',
      errorPhone: 'Please enter valid name and 10-digit mobile number',
    },

    // Cities (for scheduling)
    cities: {
      bangalore: 'Bangalore',
      mumbai: 'Mumbai',
      delhi: 'Delhi NCR',
      hyderabad: 'Hyderabad',
      chennai: 'Chennai',
      pune: 'Pune',
      kolkata: 'Kolkata',
      ahmedabad: 'Ahmedabad',
    },

    // Business Page
    business: {
      heroSubtitle: 'Enterprise Solutions',
      heroTitle: 'AI-Powered Vehicle Inspection for',
      heroTitleHighlight: 'Enterprise Partners',
      heroDesc: 'Banks, insurers, and auction platforms trust Wisedrive for pre-disbursal inspections, underwriting, and asset valuations. Our AI + trained inspectors deliver standardized, audit-ready reports.',
      requestDemo: 'Request Demo',
      viewCapabilities: 'View Capabilities',
      trustedBy: 'Trusted by Leading Enterprises',

      // Use Cases
      useCasesTitle: 'Tailored Solutions for Your Industry',
      useCasesDesc: 'Select your industry to see how Wisedrive helps',

      banks: {
        title: 'Banks & NBFCs',
        subtitle: 'Pre-Disbursal Inspections',
        desc: 'Banks can use Wisedrive to inspect used cars before approving loans. Our AI + trained inspectors assess mechanical condition, accident history, fraud signals, and valuation risk.',
        output: 'Standardized inspection report + risk score + valuation confidence',
        benefits: {
          faster: { title: 'Faster Loan Approvals', desc: 'Reduce TAT from days to hours with instant AI-powered reports' },
          npa: { title: 'Lower NPA Risk', desc: 'Identify high-risk vehicles before disbursement' },
          valuation: { title: 'Better Collateral Valuation', desc: 'AI-driven market value estimation with confidence scores' },
          fraud: { title: 'Reduced Fraud', desc: 'Detect odometer tampering, accident history & document fraud' },
        },
        stats: { npa: 'Reduction in NPA', time: 'Avg. Report Time', fraud: 'Fraud Detection' },
      },

      insurance: {
        title: 'Insurance Companies',
        subtitle: 'Underwriting & Claims Inspections',
        desc: 'Used when issuing insurance for expired policies and for post-accident inspections. Our AI detects damage and estimates repair costs more accurately and transparently.',
        output: 'Damage assessment report + repair cost estimate + audit trail',
        benefits: {
          faster: { title: 'Faster Claim Settlement', desc: 'Reduce claim processing time by 60% with instant assessments' },
          disputes: { title: 'Reduced Disputes', desc: 'Objective, AI-verified damage reports minimize conflicts' },
          estimation: { title: 'Objective Repair Estimation', desc: 'Market-linked repair cost estimates with photo evidence' },
          audit: { title: 'Audit-Ready Reports', desc: 'Complete documentation for regulatory compliance' },
        },
        stats: { claims: 'Faster Claims', savings: 'Cost Savings', audit: 'Audit Compliant' },
      },

      auction: {
        title: 'Auction & Repo Platforms',
        subtitle: 'Asset Health & Pricing',
        desc: 'Assess repo cars before auction. Our inspection gives buyers confidence, reduces disputes, and helps set accurate reserve prices based on true condition.',
        output: 'Condition report + fair market value + auction readiness score',
        benefits: {
          pricing: { title: 'Accurate Pricing', desc: 'Set realistic reserve prices based on actual vehicle condition' },
          disputes: { title: 'Fewer Disputes', desc: 'Transparent condition reports reduce buyer complaints' },
          decisions: { title: 'Informed Decisions', desc: 'Comprehensive reports help bidders make confident bids' },
          turnaround: { title: 'Fast Turnaround', desc: 'Same-day inspections keep your inventory moving' },
        },
        stats: { pricing: 'Price Accuracy', disputes: 'Fewer Disputes', clearance: 'Inventory Clearance' },
      },

      // Trust Section
      trustTitle: 'AI Accuracy You Can Trust',
      trustDesc: 'Our AI models are trained on 100,000+ real inspections, delivering unmatched accuracy',
      trustStats: {
        fraud: { value: '99.7%', label: 'Fraud Detection Rate', desc: 'Catches odometer tampering, accident history, document fraud' },
        damage: { value: '97.3%', label: 'Damage Detection', desc: 'Computer vision identifies repairs invisible to naked eye' },
        valuation: { value: '±3%', label: 'Valuation Accuracy', desc: 'Market-linked pricing with confidence intervals' },
        false: { value: '<0.1%', label: 'False Positive Rate', desc: 'Minimizes unnecessary loan rejections' },
      },

      // Technology Section
      techTitle: 'Powered by Advanced Technology',
      techDesc: 'Enterprise-grade AI infrastructure for reliable, scalable inspections',
      techItems: {
        vision: { title: 'Computer Vision AI', desc: 'Analyzes 500+ visual parameters per vehicle', feature: 'Detects paint work, panel replacements, structural damage' },
        obd: { title: 'OBD-II Deep Scan', desc: 'Reads 76+ ECU parameters for comprehensive diagnostics', feature: 'Engine, transmission, ABS, airbag fault detection' },
        valuation: { title: 'ML Valuation Engine', desc: 'Real-time market data integration', feature: 'Depreciation models, regional pricing, demand signals' },
      },

      // Transparency Section
      transparencyTitle: 'Complete Transparency & Audit Trail',
      transparencyDesc: 'Every inspection is documented with timestamped evidence for regulatory compliance',
      transparencyItems: {
        timestamp: { title: 'Timestamped Evidence', desc: 'Every photo and data point is GPS & time-stamped' },
        inspector: { title: 'Inspector Verification', desc: 'Certified inspectors with identity verification' },
        tamperProof: { title: 'Tamper-Proof Reports', desc: 'Blockchain-backed report authenticity' },
      },

      // Demo Form
      demoTitle: 'Request a Demo',
      demoDesc: 'See how Wisedrive can transform your vehicle assessment process',
      demoForm: {
        company: 'Company Name',
        name: 'Your Name',
        email: 'Work Email',
        phone: 'Phone',
        industry: 'Industry',
        selectIndustry: 'Select Industry',
        volume: 'Monthly Volume',
        selectVolume: 'Select Volume',
        submit: 'Request Demo',
        submitting: 'Submitting...',
      },
      demoSuccess: 'Demo Requested',
      demoSuccessDesc: 'Thank you for your interest in Wisedrive. Our team will contact you shortly to schedule your demo.',

      // Contact
      contactTitle: 'Questions?',
      contactDesc: 'Our enterprise team is here to help',
      salesEmail: 'support.in@wisedrive.com',
      salesPhone: '+91 99051 29146',

      backToHome: 'Back to Home',
    },
    businessPage: {
      nav: {
        consumer: 'Consumer',
        useCases: 'Use Cases',
        features: 'Features',
        howItWorks: 'How It Works',
      },
      hero: {
        viewCapabilities: 'View Capabilities',
      },
      stats: {
        citiesCovered: 'Cities Covered',
        inspectionsDone: 'Inspections Done',
        enterpriseClients: 'Enterprise Clients',
        aiAccuracy: 'AI Accuracy',
      },
      benefits: {
        title: 'Key Benefits',
      },
      output: 'OUTPUT',
      features: {
        title: 'What Enterprises Get',
        subtitle: 'Comprehensive inspection infrastructure built for scale',
        report: { title: 'AI-Powered Inspection Report', desc: '200+ point detailed assessment with photos' },
        damage: { title: 'Damage Detection & Repair Estimate', desc: 'Computer vision identifies all defects' },
        valuation: { title: 'Condition Score & Valuation', desc: 'Market-linked pricing with confidence level' },
        fraud: { title: 'Fraud & Tampering Detection', desc: 'Odometer, accident & document verification' },
        coverage: {
          titleIndia: 'Pan-India Field Coverage',
          titleMY: 'Nationwide Coverage',
          descIndia: '500+ cities with trained inspector network',
          descMY: 'All major cities with trained inspector network',
        },
        api: { title: 'Dashboard & API Integration', desc: 'RESTful APIs for seamless system integration' },
      },
      trust: {
        badge: 'Industry-Leading Accuracy',
        descriptionFull: 'Our AI models are trained on 1,00,000+ real inspections and continuously validated against ground truth data',
      },
      tech: {
        visionDesc: 'Deep learning models analyze 500+ visual parameters to detect paint inconsistencies, panel gaps, and hidden repairs',
        obdDesc: 'Direct ECU communication reads 76+ parameters including hidden fault codes, service history, and mileage verification',
        valuationDesc: 'Real-time market data + condition scoring = accurate valuations with confidence intervals',
      },
      transparency: {
        badge: '100% Transparent',
        regulatory: {
          title: 'Regulatory Compliant',
          desc: 'Reports designed for RBI, IRDAI, and audit requirements',
        },
      },
      reportPreview: {
        sampleReport: 'Sample Enterprise Report',
        inspectionReport: 'Inspection Report',
        verified: 'Verified',
        reportId: 'Report ID',
        vehicle: 'Vehicle',
        conditionScore: 'Condition Score',
        riskFlag: 'Risk Flag',
        none: 'None',
        auditTrail: 'AUDIT TRAIL',
        started: 'Inspection Started',
        photos: 'Photos Captured (45)',
        obdComplete: 'OBD Scan Complete',
        aiDone: 'AI Analysis Done',
        generated: 'Report Generated',
        digitallySigned: 'Digitally Signed',
      },
      network: {
        titleIndia: 'Pan-India Inspector Network',
        titleMY: 'Nationwide Inspector Network',
        subtitle: 'Certified professionals delivering consistent quality across {count} cities',
        stats: {
          inspectors: 'Certified Inspectors',
          cities: 'Cities Covered',
          rating: 'Avg. Inspector Rating',
          tat: 'Avg. Turnaround Time',
        },
        process: {
          title: 'Inspector Certification Process',
          steps: [
            { title: 'Application', desc: 'Background check & document verification' },
            { title: 'Training', desc: '40-hour technical training program' },
            { title: 'Certification', desc: 'Written & practical assessment' },
            { title: 'Onboarding', desc: 'Tool kit & app training' },
            { title: 'Ongoing QA', desc: 'Regular audits & re-certification' },
          ]
        }
      },
      api: {
        badge: 'Developer Friendly',
        title: 'Seamless API Integration',
        desc: "Integrate Wisedrive's inspection infrastructure directly into your existing systems with our RESTful APIs and webhooks.",
        features: [
          'RESTful API with comprehensive documentation',
          'Real-time webhook notifications',
          'Sandbox environment for testing',
          'Dedicated integration support',
          'SOC 2 compliant infrastructure',
        ],
        viewDocs: 'View API Docs',
      },
      howItWorks: {
        title: 'How It Works',
        subtitle: 'Simple 5-step process from request to report delivery',
        steps: [
          { title: 'Request Inspection', desc: 'Enterprise sends inspection request via dashboard or API' },
          { title: 'Inspector Assignment', desc: 'Wisedrive assigns nearest certified inspector' },
          { title: 'On-Ground Inspection', desc: 'Vehicle inspected with AI-powered diagnostic tools' },
          { title: 'AI Analysis', desc: 'AI generates report, valuation & risk flags' },
          { title: 'Report Delivery', desc: 'Enterprise accesses report via dashboard or API' },
        ],
      },
      cta: {
        title: 'Build Faster, Safer Auto-Finance Decisions with Wisedrive',
        subtitle: 'Join 50+ financial institutions already using our inspection infrastructure',
        contact: 'Contact Partnerships',
      },
      footer: {
        tagline: 'Enterprise Vehicle Inspection Infrastructure',
      },
    },

    // Sample Report Page
    sampleReport: {
      // Header
      reportOptions: 'Report Options',
      shareWhatsApp: 'Share via WhatsApp',
      printReport: 'Print Report',
      report: 'Report',

      // HeroSection
      points: 'Points',
      owners: 'Owners',
      overallRating: 'Overall Rating',
      recommended: 'Recommended',
      notRecommended: 'Not Recommended',
      goodCondition: 'Good condition for purchase',
      requiresRepairs: 'Requires significant repairs',
      customer: 'Customer',
      location: 'Location',
      inspectedOn: 'Inspected On',
      inspector: 'Inspector',
      marketValue: 'Recommended Market Value',
      evaluationPending: 'Evaluation Pending',

      // AssessmentSummary
      assessmentSummary: 'Assessment Summary',
      keyFindings: 'Key Findings',

      // VehicleDetails
      vehicleDetails: 'Vehicle Details',
      make: 'Make',
      model: 'Model',
      year: 'Year',
      fuel: 'Fuel',
      transmissionLabel: 'Transmission',
      mfgDate: 'Mfg. Date',
      regNumber: 'Reg. Number',
      regDate: 'Reg. Date',
      colour: 'Colour',
      engineCC: 'Engine CC',
      engineNo: 'Engine No.',
      chassisNo: 'Chassis No.',
      showMore: 'Show more details...',

      // KeyInfo
      keyInformation: 'Key Information',
      kmsDriven: 'KMs Driven',
      engine: 'Engine',
      interior: 'Interior',
      exterior: 'Exterior',
      insurance: 'Insurance',
      accident: 'Accident',
      floodDamage: 'Flood Damage',
      tyreLife: 'Tyre Life',
      minorRepairs: 'Minor Repairs',
      majorRepairs: 'Major Repairs',

      // Status labels
      statusGood: 'Good',
      statusAverage: 'Average',
      statusPoor: 'Poor',
      statusExpired: 'Expired',
      statusYes: 'Yes',
      statusNo: 'No',

      // RTO Verification
      rtoVerification: 'RTO Verification',
      allClear: 'All Clear',
      actionNeeded: 'Action Needed',
      trafficChallans: 'Traffic Challans',
      hypothecation: 'Hypothecation',
      blacklist: 'Blacklist',
      bankNOC: 'Bank NOC',
      financier: 'Financier',

      // OBD
      obdDiagnostics: 'OBD-2 Diagnostics',
      errors: 'Errors',
      error: 'Error',
      criticalIssues: '{count} critical {issueWord} require immediate attention',
      possibleCauses: 'Possible Causes',
      symptoms: 'Symptoms',
      solutions: 'Solutions',
      critical: 'Critical',
      warning: 'Warning',
      noDiagnosticErrors: 'No Diagnostic Errors',
      allSystemsNormal: 'All systems functioning normally',

      // Inspection Details
      inspectionDetails: 'Inspection Details',
      checkpoints: 'Checkpoints',
      categories: 'Categories',
      swipeToSee: '← Swipe to see more checkpoints →',
      question: 'Question',
      answer: 'Answer',
      instruction: 'Instruction',
      followUp: 'Follow-up',
      photo: 'Photo',
      pts: 'pts',

      // Footer
      inspectWise: 'Inspect Wise, Drive Smart - Professional vehicle inspection services with comprehensive reports.',
      reportFeatures: 'Report Features',
      methodsUsed: 'Methods Used',
      easyToRead: 'Easy to Read',
      easyToTrack: 'Easy to Track',
      comprehensive: 'Comprehensive',
      physicalInspection: 'Physical Inspection',
      aiAnalysis: 'AI Analysis',
      obd2Scanning: 'OBD2 Scanning',
      features: 'Features',
      methods: 'Methods',
      published: 'Published',

      // Modals
      inspectionVideo: 'Inspection Video',
      inspectionPhoto: 'Inspection Photo',
      duration: 'Duration',
      close: 'Close',
      insuranceDetails: 'Insurance Details',
      insurerName: 'Insurer Name',
      policyNumber: 'Policy Number',
      policyType: 'Policy Type',
      expiryDate: 'Expiry Date',
      idvValue: 'IDV Value',
      status: 'Status',
      tyreConditionDetails: 'Tyre Condition Details',
      averageTyreLife: 'Average Tyre Life',
      treadLife: 'Tread Life',
      brand: 'Brand',
      totalMinorRepairs: 'Total Minor Repairs',
      totalMajorRepairs: 'Total Major Repairs',
      minor: 'Minor',
      major: 'Major',
      sparePart: 'Spare Part',
      labor: 'Labor',
    },
  },

  // Bahasa Malaysia translations
  bm: {
    // Navigation
    nav: {
      products: 'Produk',
      howItWorks: 'Cara Ia Berfungsi',
      technology: 'Teknologi',
      aboutUs: 'Tentang Kami',
      forBusinesses: 'Untuk Perniagaan',
      getStarted: 'Mula Sekarang',
      selectRegion: 'Pilih Wilayah',
      selectLanguage: 'Bahasa',
    },

    // B2B Banner
    b2bBanner: {
      text: 'Adakah anda Bank, Insurans, atau Platform Lelongan?',
      cta: 'Terokai Penyelesaian Enterprise',
    },

    // Hero Section
    hero: {
      badge: 'Platform Pemeriksaan Kereta Terpakai #1 di Malaysia',
      badgeMY: 'Platform Pemeriksaan Kereta Terpakai #1 di Malaysia',
      headline1: 'Tiada Lagi Penipuan.',
      headline2: 'Beli dengan Keyakinan Penuh.',
      subheadline: 'Membeli Kereta Terpakai?',
      subheadlineSuffix: 'Kami Sedia Membantu.',
      description: 'Setiap tahun, {count} kehilangan wang kerana kereta terpakai bermasalah. {inspection} kami mendedahkan setiap kecacatan tersembunyi — penipuan odometer, kerosakan kemalangan, masalah enjin — sebelum anda bayar sebarang ringgit.',
      descriptionMY: 'Setiap tahun, {count} kehilangan wang kerana kereta terpakai bermasalah. {inspection} kami mendedahkan setiap kecacatan tersembunyi — penipuan odometer, kerosakan kemalangan, masalah enjin — sebelum anda bayar sebarang ringgit.',
      lakhsOfIndians: 'beribu-ribu rakyat India',
      thousandsOfMalaysians: 'beribu-ribu rakyat Malaysia',
      aiInspection: 'Pemeriksaan AI 200+ titik',
      bookInspection: 'Tempah Pemeriksaan',
      viewSampleReport: 'Lihat Laporan Contoh',
      avgNegotiated: 'Purata harga dirunding turun',
      worthEveryRupee: 'Berbaloi Setiap Rupee',
      worthEveryRinggit: 'Berbaloi Setiap Ringgit',
      catchTitle: 'Kami Tangkap Apa Yang Lain Terlepas:',
      odometerTampering: 'Pengubahan Odometer',
      hiddenAccident: 'Kerosakan Kemalangan Tersembunyi',
      floodDamaged: 'Kereta Rosak Banjir',
      fakeDocs: 'Dokumen Palsu & Senarai Hitam',
      checkPoints: 'Titik Semakan',
      aiPowered: 'Dikuasakan AI',
      moreAccurate: '20x lebih tepat',
    },

    //step process section (From booking to buying)
    howItWorks: {
      steps: [
        {
          icon: Calendar,
          number: '01',
          title: 'Tempah dalam 60 Saat',
          description: 'Jadualkan pemeriksaan pada masa dan lokasi pilihan anda. Pakar kami akan datang kepada anda.',
          highlight: 'Pembatalan percuma',
        },
        {
          icon: FileSearch,
          number: '02',
          title: 'Pemeriksaan Pakar',
          description: 'Mekanik bertauliah kami menjalankan pemeriksaan menyeluruh 200+ titik dengan bantuan AI.',
          highlight: '2-3 jam',
        },
        {
          icon: FileCheck,
          number: '03',
          title: 'Terima Laporan Digital',
          description: 'Terima laporan terperinci dengan penilaian AI, gambar, dan anggaran nilai pasaran.',
          highlight: 'Penghantaran segera',
        },
        {
          icon: Shield,
          number: '04',
          title: 'Beli dengan Perlindungan',
          description: 'Dapatkan perlindungan waranti dan pilihan pembiayaan berdasarkan skor pemeriksaan kereta anda.',
          highlight: 'Layak waranti',
        },
      ],
      subTitle: 'Proses Mudah 4 Langkah',
      title: 'Daripada Tempahan hingga Pembelian',
      description: 'Tiada keraguan. Ketahui dengan tepat apa yang anda beli.'

    },
    // Services Section
    services: {
      badge: 'Penyelesaian Pemilikan Kereta Lengkap',
      headline1: 'Semua Yang Anda Perlukan,',
      headline2: 'Di Bawah Satu Bumbung',
      description: 'Dari pemeriksaan ke waranti ke pembiayaan — kami melindungi perjalanan kereta terpakai anda.',

      // Inspection Card
      inspection: {
        title: 'Pemeriksaan Kereta AI',
        startingFrom: 'Bermula dari',
        description: 'Pemeriksaan 200+ titik dikuasakan AI yang menangkap apa yang lain terlepas',
        features: ['Analisis Dikuasakan AI', 'Laporan Digital dalam 3 Jam', 'Diagnostik OBD2', 'Pengesahan JPJ'],
        featuresMY: ['Analisis Dikuasakan AI', 'Laporan Digital dalam 3 Jam', 'Diagnostik OBD2', 'Pengesahan JPJ'],
        bookBtn: 'Tempah Pemeriksaan',
      },

      // Warranty Card
      warranty: {
        title: 'Waranti Lanjutan',
        mostPopular: 'PALING POPULAR',
        description: 'Perlindungan gred bilik pameran dengan kadar kelulusan tuntutan 98%',
        features: ['Rangkaian Bengkel OEM', 'Pembayaran Tuntutan 90%', 'Bantuan Tepi Jalan', 'Liputan Seluruh Negara'],
        featuresMY: ['Rangkaian Bengkel OEM', 'Pembayaran Tuntutan 90%', 'Bantuan Tepi Jalan', 'Liputan Seluruh Negara'],
        buyBtn: 'Beli Waranti',
        fileClaim: 'Failkan Tuntutan',
      },

      // Financing Card
      financing: {
        title: 'Pembiayaan Kereta',
        interestFrom: 'Faedah dari',
        description: 'Bandingkan tawaran dari 15+ bank dan dapatkan kelulusan segera',
        features: ['15+ Rakan Bank', 'Kelulusan Segera', 'Proses 100% Digital', 'Pilihan EMI Terendah'],
        compareBtn: 'Bandingkan Pinjaman',
      },
      bottomStats: [
        { icon: Users, value: '50,000+', label: 'Kereta Diperiksa' },
        { icon: Star, value: '4.8/5', label: 'Penilaian Pelanggan' },
        { icon: Clock, value: '< 3 Jam', label: 'Penghantaran Laporan' },
        { icon: Shield, value: '98%', label: 'Kelulusan Tuntutan' }
      ],

      // Stats
      stats: {
        carsInspected: 'Kereta Diperiksa',
        customerRating: 'Penilaian Pelanggan',
        reportDelivery: 'Penghantaran Laporan',
        claimApproval: 'Kelulusan Tuntutan',
      },
    },

    // Inspection Modal
    inspectionModal: {
      title: 'Tempah Pemeriksaan Kereta',
      subtitle: '200+ Titik Semakan • Laporan dalam 2-3 Jam',
      selectPlan: 'Pilih Pelan',
      yourDetails: 'Butiran Anda',
      verifyOtp: 'Sahkan OTP',
      vehicleInfo: 'Maklumat Kenderaan',
      schedule: 'Jadual',
      payment: 'Pembayaran',

      inspectionSteps: [
        { num: 1, label: 'Pilih Pelan' },
        { num: 2, label: 'Butiran Anda' },
        { num: 3, label: 'Sahkan OTP' },
        { num: 4, label: 'Maklumat Kenderaan' },
        { num: 5, label: 'Jadual' },
        { num: 6, label: 'Pembayaran' },
      ],

      // Step 1
      choosePlan: 'Pilih Pakej Pemeriksaan Anda',
      standard: 'Standard',
      luxury: 'Mewah',
      forBudgetCars: 'Untuk Kereta Bajet',
      forPremiumCars: 'Untuk Kereta Premium',
      recommended: 'DISYORKAN',
      checkPoints: 'Titik Semakan',
      inclTaxes: 'termasuk cukai',
      continueWith: 'Teruskan dengan Pakej',
      package: '',
      brands: 'Jenama',
      regPlaceholder: 'cth., ABC1234',
      luxuryAddons: '+ OBD2 + JPJ',
      inspectionCategories: [
        {
          id: 'physical',
          title: 'Pemeriksaan Fizikal / Manual',
          points: 135,
          icon: 'car',
          items: [
            'Pemeriksaan Enjin & Transmisi',
            'Pemeriksaan Komponen Elektrik',
            'Pemeriksaan Komponen Mekanikal',
            'Pemeriksaan Dalaman & Luaran'
          ],
          benefits: [
            'Pemeriksaan Kenderaan Banjir',
            'Pemeriksaan Pembaikan Besar Enjin',
            'Pemeriksaan Fungsi Bateri',
            'Pemeriksaan Manipulasi Odometer',
            'Pemeriksaan Sistem Brek',
            'Pemeriksaan Sistem Bahan Api'
          ],
          includedIn: ['standard', 'luxury']
        },
        {
          id: 'obd2',
          title: 'Ujian Pengimbas OBD2 Lanjutan',
          points: 76,
          icon: 'scan',
          items: [
            'Modul Kawalan Enjin (ECM)',
            'Modul Kawalan Transmisi',
            'Modul Kawalan Badan (BCM)',
            'Pemeriksaan & Analisis Kod Ralat'
          ],
          benefits: [
            'Analisis Kebarangkalian Kegagalan Enjin',
            'Kebarangkalian Kegagalan Transmisi',
            'Pemeriksaan Kestabilan Kelajuan Tinggi',
            'Pemeriksaan Pencegahan Pembaikan Mahal'
          ],
          includedIn: ['luxury']
        },
        {
          id: 'rto',
          title: 'Pengesahan RTO & Polis',
          points: 29,
          icon: 'shield',
          items: [
            'Pemeriksaan Pinjaman & Insurans',
            'Pemeriksaan Saman Trafik & Senarai Hitam',
            'Pemeriksaan Kesahihan PUC & RC',
            'Pemeriksaan Maklumat Pemilik & Kenderaan'
          ],
          benefits: [
            'Pemeriksaan NOC Pinjaman',
            'Pemeriksaan Tamat Tempoh Insurans',
            'Pemeriksaan Status Senarai Hitam',
            'Pengesahan Pangkalan Data Vaahan'
          ],
          includedIn: ['luxury']
        },
        {
          id: 'support',
          title: 'Sokongan Teknikal Tambahan',
          points: 'PERCUMA',
          icon: 'headphones',
          items: [
            'Anggaran Harga Adil',
            'Anggaran Kos Pembaikan',
            'Nasihat Mekanik Pakar',
            'Jaminan Lanjutan (sehingga 2 tahun)'
          ],
          benefits: [],
          includedIn: ['standard', 'luxury']
        }
      ],
      // Inspection Categories
      inspectionCoverage: 'Liputan Pemeriksaan Titik Semakan',
      physicalInspection: 'Pemeriksaan Fizikal / Manual',
      obd2Scanner: 'Ujian Pengimbas OBD2 Lanjutan',
      rtoVerification: 'Pengesahan JPJ & Polis',
      jpjVerification: 'Pengesahan JPJ & Polis',
      technicalSupport: 'Sokongan Teknikal Tambahan',
      luxuryOnly: 'MEWAH',
      additionalBenefits: 'Manfaat Tambahan:',
      upgradePrompt: 'Naik taraf ke Pakej Luxury',
      upgradePrompt1: 'untuk Ujian Pengimbas OBD2 & Pengesahan RTO',
      extraCheckpoints: 'titik semakan tambahan',

      continueWith: 'Teruskan dengan',
      selected: 'Terpilih',
      // Step 2
      unlocking: 'Membuka kunci',
      inspection: 'Pemeriksaan',
      registerMobile: 'Daftar Dengan Nombor Telefon',
      sendOtpDesc: 'Kami akan menghantar OTP untuk mengesahkan nombor anda',
      fullName: 'Nama Penuh',
      enterFullName: 'Masukkan nama penuh anda',
      mobileNumber: 'Nombor Telefon',
      digitMobile: 'Nombor telefon 10 digit',
      back: 'Kembali',
      sendOtp: 'Hantar OTP',

      // Step 3 - OTP
      verifyOtpTitle: 'Sahkan OTP',
      enterCode: 'Masukkan kod 6 digit yang dihantar ke',
      resendIn: 'Hantar semula OTP dalam',
      resendOtp: 'Hantar Semula OTP',
      changeNumber: 'Tukar Nombor',
      verifyOtpBtn: 'Sahkan OTP',
      didntReceive: 'Tidak terima? Semak peti masuk SMS atau folder spam.',

      // Step 4 - Vehicle
      mobileVerified: 'Telefon Disahkan!',
      enterRegNumber: 'Masukkan nombor pendaftaran kereta anda untuk ambil butiran secara automatik',
      regNumber: 'Nombor Pendaftaran',
      vehicleFound: 'Kenderaan Ditemui!',
      makeModel: 'Jenama & Model',
      fuelType: 'Jenis Bahan Api',
      color: 'Warna',
      regDate: 'Tarikh Daftar',
      rto: 'JPJ',
      change: 'Tukar',
      confirm: 'Sahkan',
      skipEnterManually: 'Langkau & Masukkan Butiran Secara Manual',

      // Step 5 - Schedule
      selectCity: 'Pilih Bandar Anda',
      orTypeCity: 'Atau taip bandar anda...',
      pickDate: 'Pilih Tarikh',
      chooseTime: 'Pilih Slot Masa',
      emailOptional: 'E-mel (Pilihan - untuk laporan terperinci)',
      emailPlaceholder: 'anda@email.com',
      yourSelection: 'Pilihan Anda',
      proceedPayment: 'Teruskan ke Pembayaran',
      carBrand: 'Jenama Kereta',
      carBrandPlaceholder: 'cth., Proton',
      carModel: 'Model Kereta',
      carModelPlaceholder: 'cth., Saga',
      locationLabel: 'Lokasi',
      dateLabel: 'Tarikh',
      timeLabel: 'Masa',
      paid: 'DIBAYAR',
      inspectionLabel: 'Pemeriksaan',

      // Step 6 - Payment
      orderSummary: 'Ringkasan Pesanan',
      secure: 'SELAMAT',
      checkpointInspection: 'Pemeriksaan Titik Semakan',
      whatsIncluded: 'Apa Yang Termasuk',
      physicalInsp: 'Pemeriksaan Fizikal',
      obd2Test: 'Ujian Pengimbas OBD2',
      digitalReport: 'Laporan Digital',
      fairPriceEst: 'Anggaran Harga Saksama',
      expertAdvice: 'Nasihat Pakar',
      trustIndicators: {
        secure: '100% Selamat',
        encrypted: 'Pembayaran Disulitkan',
        reschedule: 'Penjadualan Semula Percuma',
        upTo24hrs: 'Sehingga 24 jam Sebelum',
        rating: 'Penilaian',
        reviews: 'Ulasan',
      },
      selectPayment: 'Pilih Kaedah Pembayaran',
      upi: 'FPX',
      upiDesc: 'Perbankan Dalam Talian',
      card: 'Kad',
      cardDesc: 'Kredit/Debit',
      netBanking: 'E-Wallet',
      allBanks: 'GrabPay, TnG',
      inspectionFee: 'Yuran Pemeriksaan',
      taxesIncluded: 'Cukai (Termasuk)',
      totalAmount: 'Jumlah Keseluruhan',
      moneyBack: 'Jaminan Wang Dikembalikan 100%',
      moneyBackDesc: 'Bayaran balik penuh jika pemeriksa tidak tiba tepat pada masa',
      pay: 'Bayar',
      securedBy: 'Dijamin oleh rakan pembayaran yang dipercayai',
      razorpay: 'PayPal',
      visa: 'Visa',
      mastercard: 'Mastercard',
      upi: 'UPI',

      // Step 7 - Confirmation
      bookingConfirmed: 'Tempahan Disahkan!',
      inspectorAssigned: 'Pemeriksaan anda dijadualkan. Kami sedang menetapkan pemeriksa terbaik untuk kereta anda.',
      bookingDetails: 'Butiran Tempahan',
      bookingId: 'ID Tempahan',
      inspectionDate: 'Tarikh Pemeriksaan',
      timeSlot: 'Slot Masa',
      packageLabel: 'Pakej',
      carLabel: 'Kereta',
      amountPaid: 'Jumlah Dibayar',
      whatNext: 'Apa Seterusnya?',
      steps: {
        confirmation: { title: 'Pengesahan', desc: 'SMS & WhatsApp dihantar', time: 'Selesai' },
        assignment: { title: 'Penetapan Pemeriksa', desc: 'Dalam 2 jam', time: '2 jam' },
        inspection: { title: 'Pemeriksaan Di Lokasi', desc: 'Di lokasi anda', time: 'Dijadualkan' },
        report: { title: 'Laporan Digital', desc: 'Dengan analisis AI', time: '2-3 jam' },
      },
      needReschedule: 'Perlu jadual semula?',
      freeChanges: 'Perubahan percuma sehingga 24 jam sebelum',
      callSupport: 'Hubungi Sokongan',
      confirmationSent: 'Pengesahan dihantar ke',
      close: 'Tutup',
      bookAnother: 'Tempah Pemeriksaan Lain',
    },

    // Warranty Modal
    warrantyModal: {
      title: 'Waranti Kereta Lanjutan',
      subtitle: '98% Kelulusan Tuntutan • Bengkel OEM',
      selectPlan: 'Pilih Pelan',
      yourDetails: 'Butiran Anda',
      verifyOtp: 'Sahkan OTP',
      confirmation: 'Pengesahan',
      warrantySteps: [
        { num: 1, label: 'Pilih Pelan' },
        { num: 2, label: 'Butiran Anda' },
        { num: 3, label: 'Sahkan OTP' },
        { num: 4, label: 'Pengesahan' },
      ],

      // Step 1
      choosePlan: 'Pilih Pelan Waranti Anda',
      quarterly: 'Suku Tahunan',
      sixMonths: '6 Bulan',
      annual: 'Tahunan',
      perQuarter: 'setiap suku tahun',
      forSixMonths: 'untuk 6 bulan',
      perYear: 'setahun',
      bestValue: 'NILAI TERBAIK',
      coPay: 'Bayaran Bersama',
      wePay: 'Kami Bayar',
      continue: 'Teruskan',

      // Step 2
      unlockingWarranty: 'Membuka kunci',
      warranty: 'Waranti',

      // Step 4 - Confirmation
      requestSubmitted: 'Permintaan Dihantar!',
      teamWillContact: 'Pasukan Kami Akan Menghubungi Anda Tidak Lama Lagi',
      expertWillCall: 'Pakar waranti Wisedrive akan menghubungi anda dalam {hours} untuk membincangkan pelan {plan} anda dan melengkapkan pendaftaran.',
      twoToFourHours: '2-4 jam',
      name: 'Nama',
      phone: 'Telefon',
      plan: 'Pelan',
      amount: 'Jumlah',
      supportHours: 'Isn-Sab, 9PG-7MLM',
      supportPhone: 'Sokongan',
      supportNumber: '+60 122559610',
      done: 'Selesai',
      warrantyPackages: [
        { id: 'quarterly', name: 'Suku Tahunan', price: 1499, period: 'setiap suku', duration: '3 Bulan', coPay: '20%', payout: '80%', features: ['Enjin & Transmisi', 'Komponen Elektrik', 'Komponen Mekanikal', 'Waranti AC', 'Bantuan Tepi Jalan'] },
        { id: 'halfyearly', name: '6 Bulan', price: 2999, period: 'untuk 6 bulan', duration: '6 Bulan', coPay: '10%', payout: '90%', recommended: true, features: ['Enjin & Transmisi', 'Komponen Elektrik', 'Komponen Mekanikal', 'Waranti AC', 'Bantuan Tepi Jalan', 'Liputan Seluruh Negara'] },
        { id: 'yearly', name: 'Tahunan', price: 4999, period: 'setiap tahun', duration: '12 Bulan', coPay: '10%', payout: '90%', features: ['Enjin & Transmisi', 'Komponen Elektrik', 'Komponen Mekanikal', 'Waranti AC', 'Bantuan Tepi Jalan', 'Liputan Seluruh Negara', 'Sokongan 24/7', 'Bengkel OEM'] }
      ]
    },

    // Claim Modal
    claimModal: {
      title: 'Failkan Tuntutan Waranti',
      subtitle: '98% Kelulusan • Pemprosesan 24 jam',
      howItWorks: 'Cara Proses Tuntutan Berfungsi',
      steps: {
        submit: { title: 'Hantar Tuntutan', desc: 'Isi borang tuntutan' },
        upload: { title: 'Muat Naik Gambar', desc: 'Lampirkan gambar (pilihan)' },
        review: { title: 'Kami Semak', desc: 'Semakan dalam 24 jam' },
        repair: { title: 'Dibaiki', desc: 'Lawati bengkel OEM' },
      },
      startProcess: 'Mulakan Proses Tuntutan',
      warrantyId: 'ID Waranti / Nombor Polisi',
      selectClaimType: 'Pilih Jenis Tuntutan',
      claimTypes: {
        engine: 'Masalah Enjin',
        transmission: 'Masalah Transmisi',
        electrical: 'Masalah Elektrik',
        ac: 'Masalah AC / Penyejukan',
        mechanical: 'Bahagian Mekanikal',
      },
      describeIssue: 'Huraikan masalah',
      submitClaim: 'Hantar Tuntutan',
      claimSubmitted: 'Tuntutan Dihantar!',
      contactWithin24: 'Kami akan menghubungi anda dalam 24 jam.',
    },

    // Trust Section
    trust: {
      claimRate: 'Kadar Tuntutan',
      inspected: 'Diperiksa',
      satisfaction: 'Kepuasan',
      avgSaved: 'Purata Disimpan',
      whyChooseUs: 'Mengapa Pilih Kami',
      smartestInvestment: 'Pelaburan Paling Bijak Sebelum Kereta Anda',
      inspectionCanSave: 'Pemeriksaan {price} boleh menyelamatkan anda dari kesilapan {bigPrice}+.',
      reasons: {
        catchProblems: { title: 'Tangkap Masalah Tersembunyi', desc: 'Semakan 200+ titik kami mendedahkan masalah bernilai {range} dalam pembaikan' },
        oemWorkshop: { title: 'Rangkaian Bengkel OEM', desc: 'Perkongsian langsung dengan pusat servis yang dibenarkan' },
        reportHours: { title: 'Laporan dalam Jam', desc: 'Dapatkan laporan digital komprehensif pada hari yang sama' },
        negotiation: { title: 'Kuasa Rundingan', desc: 'Purata {amount} disimpan dengan laporan terperinci kami' },
      },
      testimonial: 'Menemui masalah transmisi yang menjimatkan saya {amount} dalam pembaikan.',
      testimonialAuthor: 'Ahmad R., Kuala Lumpur',
      testimonialAuthorMY: 'Ahmad R., Kuala Lumpur',
    },

    // AI Technology Section
    aiTech: {
      poweredBy: 'Dikuasakan oleh AI Generatif',
      headline: 'Jangan Percaya Mata Anda.',
      headlinePart2: 'Percaya AI Kami.',
      description: 'Penipu semakin bijak. AI kami lebih bijak. Dilatih dengan {count}+ pemeriksaan sebenar, kami tangkap apa yang pakar mekanik pun terlepas.',
      trainingData: 'Titik Data Latihan',
      checkpoints: 'Titik Semakan Pemeriksaan',
      reportDelivery: 'Penghantaran Laporan',
      customerSavings: 'Purata Penjimatan Pelanggan',
      problemsTitle: 'Masalah Yang AI Kami Tangkap',
      problemsSubtitle: '(Yang Lain Terlepas)',
      problems: {
        odometer: { title: 'Odometer Diubah', desc: 'AI mengesan penipuan perbatuan dengan ketepatan 99.7%' },
        accidents: { title: 'Kemalangan Tersembunyi', desc: 'Penglihatan komputer mengesan panel yang dicat semula & pembaikan' },
        engine: { title: 'Masalah Enjin', desc: 'Imbasan OBD2 mendedahkan kod kerosakan tersembunyi' },
        flood: { title: 'Kerosakan Banjir', desc: 'Sensor mengesan kerosakan air dalam elektronik' },
      },
      techEdge: 'Kelebihan Teknologi Kami',
      capabilities: {
        vision: { stat: '20x', highlight: 'Lebih Tepat', title: 'Penglihatan Komputer', desc: 'Mengesan variasi ketebalan cat, jurang panel, dan pembaikan badan yang tidak kelihatan pada mata kasar' },
        ai: { stat: '99.7%', highlight: 'Pengesanan Penipuan', title: 'AI Pembelajaran Mendalam', desc: 'Dilatih dengan {count}+ pemeriksaan untuk mengenal pasti pengubahan odometer dan dokumen palsu' },
        obd: { stat: '76+', highlight: 'Parameter ECU', title: 'Diagnostik OBD2', desc: 'Membaca kod enjin, transmisi, ABS & beg udara yang mekanik sering terlepas' },
        predictive: { stat: '12-24', highlight: 'Bulan Ke Hadapan', title: 'Analisis Ramalan', desc: 'Meramalkan kerosakan berpotensi berdasarkan corak haus dan data sejarah' },
      },
      categories: 'Titik Merentasi 4 Kategori Kritikal',
      categoryItems: {
        exterior: { name: 'Luaran & Badan', items: ['Keadaan Cat', 'Jurang Panel', 'Semakan Karat', 'Cermin & Lampu'] },
        engine: { name: 'Enjin & Mekanikal', items: ['Kualiti Minyak', 'Tali Sawat & Hos', 'Paras Cecair', 'Sistem Ekzos'] },
        electronics: { name: 'Elektronik & OBD', items: ['Imbasan ECU', 'Kod Kerosakan', 'Kesihatan Sensor', 'Ujian Bateri'] },
        documents: { name: 'Dokumen & Undang-undang', items: ['Pengesahan Geran', 'Status Insurans', 'Semakan Pinjaman', 'Imbasan Senarai Hitam'] },
        documentsMY: { name: 'Dokumen & Undang-undang', items: ['Pengesahan Geran', 'Status Insurans', 'Semakan Pinjaman', 'Imbasan Senarai Hitam'] },
      },
      aiGuarantee: 'Setiap pemeriksaan disokong oleh',
      aiAccuracyGuarantee: 'Jaminan Ketepatan AI',
    },

    // Financial Services
    finance: {
      badge: 'Pinjaman Diproses',
      badgeAmount: '250M+',
      badgeAmountMY: '250M+',
      headline: 'Biayai Kereta Impian Anda pada',
      headlineHighlight: 'Kadar Terbaik',
      description: 'Bandingkan tawaran pinjaman segera dari bank terkemuka Malaysia. Dapatkan pra-kelulusan dalam minit, bukan hari. 100% telus, tiada yuran tersembunyi.',
      descriptionMY: 'Bandingkan tawaran pinjaman segera dari bank terkemuka Malaysia. Dapatkan pra-kelulusan dalam minit, bukan hari. 100% telus, tiada yuran tersembunyi.',
      stats: {
        bankPartners: { value: '15+', label: 'Rakan Bank', sublabel: 'Bank & NBFC Teratas' },
        quickApproval: { value: '24jam', label: 'Kelulusan Cepat', sublabel: 'Pencairan Hari Sama' },
        startingRate: { value: '3.5%', label: 'Kadar Bermula', sublabel: 'Terendah di Pasaran' },
        digitalProcess: { value: '100%', label: 'Proses Digital', sublabel: 'Tiada Kertas Kerja' },
      },
      whyFinance: 'Mengapa Pembiayaan dengan Wisedrive?',
      benefits: [
        'Tiada caj tersembunyi atau yuran pemprosesan',
        'Tawaran pra-lulus dari rakan yang dipercayai',
        'Kadar istimewa untuk pelanggan Wisedrive',
        'pelanggan gembira dibiayai',
      ],
      trustedPartners: 'Rakan Perbankan Yang Dipercayai',

      // EMI Calculator
      emiCalculator: 'Kalkulator Ansuran',
      estimatePayment: 'Anggarkan bayaran bulanan anda',
      loanAmount: 'Jumlah Pinjaman',
      loanTenure: 'Tempoh Pinjaman',
      months: 'Bulan',
      interestRate: 'Kadar Faedah',
      bestRate: 'Kadar Terbaik',
      monthlyEmi: 'Ansuran Bulanan Anda',
      totalPayable: 'Jumlah Perlu Dibayar',
      compareOffers: 'Bandingkan Semua Tawaran Pinjaman',
      secureComparison: 'Perbandingan Selamat & Segera',
    },

    // Benefits Section
    benefits: {
      why: 'Mengapa Wisedrive',
      smartChoice: 'Pilihan Bijak untuk Kereta Terpakai',
      items: {
        check: { title: 'Semakan 200+ Titik', stat: '20x', desc: 'lebih tepat' },
        report: { title: 'Laporan Segera', stat: '3jam', desc: 'masa penghantaran' },
        warranty: { title: 'Sedia Waranti', stat: '<1.5%', desc: 'kadar tuntutan' },
        loans: { title: 'Kadar Pinjaman Terbaik', stat: '15+', desc: 'rakan bank' },
        digital: { title: '100% Digital', stat: '0', desc: 'kertas kerja' },
        support: { title: 'Sokongan 24/7', stat: '98%', desc: 'kepuasan' },
      },
      ctaTitle: 'Bersedia Membeli dengan Keyakinan?',
      ctaDesc: 'Tempah pemeriksaan anda sekarang dan jimat purata {amount} dalam rundingan',
    },
    // Comparison Section
    comparison: {
      badge: "Mengapa Kami Berbeza",
      title: "Wisedrive vs Mekanik Tempatan",
      subtitle: "Pemeriksaan tempatan tidak dapat menawarkan perlindungan waranti. Kami bukan sekadar memeriksa – kami {protect} pembelian anda.",
      protect: "melindungi pembelian anda",
      table: {
        feature: "Ciri",
        wisedrive: "Wisedrive",
        local: "Mekanik Tempatan",
      },
      features: {
        points: {
          title: "Titik Pemeriksaan",
          wisedrive: "200+ titik semakan dikuasakan AI",
          local: "20-30 semakan asas",
        },
        warranty: {
          title: "Perlindungan Waranti",
          wisedrive: "Perlindungan sehingga 2 tahun termasuk",
          local: "Tiada waranti ditawarkan",
        },
        report: {
          title: "Laporan Digital",
          wisedrive: "Laporan terperinci dengan gambar & penilaian AI",
          local: "Maklum balas lisan sahaja",
        },
        fraud: {
          title: "Pengesanan Penipuan",
          wisedrive: "Pengesahan JPJ & Polis disertakan",
          local: "Tidak tersedia",
        },
        obd: {
          title: "Diagnostik OBD2",
          wisedrive: "76 parameter ECU diimbas",
          local: "Semakan visual asas sahaja",
        },
        price: {
          title: "Ketelusan Harga",
          wisedrive: "Anggaran nilai pasaran yang saksama",
          local: "Bias kepada penjual",
        },
      },
      benefits: [
        { title: "Pembelian Terlindung", desc: "Liputan waranti untuk ketenangan fikiran" },
        { title: "Kelulusan Tuntutan 98%", desc: "Kadar tuntutan mendahului industri" },
        { title: "Bengkel OEM", desc: "Pusat servis berautoriti sahaja" },
        { title: "Sokongan 24/7", desc: "Bantuan sepanjang masa" },
      ],
      cta: "Jangan berpuas hati dengan pemeriksaan tanpa perlindungan. {bold}",
      ctaBold: "Dapatkan keyakinan yang disokong waranti.",
    },
    // Warranty Showcase
    warrantyShowcase: {
      badge: "Rangkaian Bengkel OEM",
      title: "Waranti Gred Bilik Pameran",
      subtitle: "Dapatkan perlindungan peringkat pengeluar untuk kereta terpakai anda. Bekerjasama dengan pusat servis berautoriti semua jenama utama di seluruh India.",
      subtitleMY: "Dapatkan perlindungan peringkat pengeluar untuk kereta terpakai anda. Bekerjasama dengan pusat servis berautoriti semua jenama utama di seluruh Malaysia.",
      stats: {
        claimApproval: "Kelulusan Tuntutan",
        claimProcessing: "Pemprosesan Tuntutan",
        serviceCenters: "Pusat Servis",
        deductible: "Bayaran Lebih",
      },
      coverage: {
        engine: {
          title: "Enjin & Transmisi",
          desc: "Perlindungan lengkap untuk semua komponen enjin dan transmisi termasuk transmisi automatik",
          highlight: "Perlindungan Penuh",
        },
        electrical: {
          title: "Sistem Elektrik",
          desc: "Pendawaian, bateri, infotainmen, lampu, penderia, dan semua komponen elektronik",
          highlight: "Perlindungan Penuh",
        },
        mechanical: {
          title: "Bahagian Mekanikal",
          desc: "Gantungan, penyerap hentak, stereng, sistem brek, dan pacuan",
          highlight: "Perlindungan Penuh",
        },
        cooling: {
          title: "AC & Penyejukan",
          desc: "Pemampat, pemeluwap, sistem penyejukan, dan semua komponen kawalan iklim",
          highlight: "Perlindungan Penuh",
        },
        roadside: {
          title: "Bantuan Tepi Jalan",
          desc: "Sokongan kecemasan 24/7 dengan menunda, menghidupkan bateri, dan pembaikan di tempat",
          highlight: "Termasuk Percuma",
        },
        network: {
          titleIndia: "Rangkaian Seluruh India",
          titleMY: "Rangkaian Seluruh Negara",
          descIndia: "Akses ke 7000+ pusat servis berautoriti di semua bandar utama",
          descMY: "Akses ke 500+ pusat servis berautoriti di semua bandar utama",
          highlightIndia: "7000+ Pusat",
          highlightMY: "500+ Pusat",
        },
      },
      banner: {
        badge: "Disokong oleh Pemeriksaan",
        title: "Waranti Percuma dengan Setiap Pemeriksaan",
        desc: "Kereta yang lulus pemeriksaan AI kami secara automatik layak untuk perlindungan waranti lanjutan. Tiada terma tersembunyi, tiada kejutan.",
        duration: "Sehingga 2 Tahun",
        durationLabel: "Tempoh Perlindungan",
        payout: "90%",
        payoutLabel: "Kami Bayar Tuntutan",
        authorized: "Berautoriti",
      },
    },
    // Loan Comparison
    loanComparison: {
      title: "Bandingkan Tawaran Pinjaman",
      subtitle: "Dapatkan kadar terbaik daripada 15+ bank & NBFC",
      loanDetails: "Butiran Pinjaman",
      carValue: "Nilai Kereta",
      carValuePlaceholder: "cth., 700000",
      loanAmount: "Jumlah Pinjaman",
      loanAmountPlaceholder: "cth., 500000",
      tenure: "Tempoh Pinjaman (Bulan)",
      tenureOptions: {
        12: "12 Bulan (1 Tahun)",
        24: "24 Bulan (2 Tahun)",
        36: "36 Bulan (3 Tahun)",
        48: "48 Bulan (4 Tahun)",
        60: "60 Bulan (5 Tahun)",
        72: "72 Bulan (6 Tahun)",
      },
      employmentType: "Jenis Pekerjaan",
      employmentOptions: {
        salaried: "Bergaji",
        self_employed: "Bekerja Sendiri",
      },
      compareBtn: "Bandingkan Tawaran Pinjaman",
      comparingBtn: "Membandingkan Tawaran...",
      bestOfferFound: "Tawaran Terbaik Ditemui!",
      bestOfferDesc: "{lender} menawarkan EMI terendah untuk pinjaman anda",
      bestOfferBadge: "TAWARAN TERBAIK",
      monthlyEmi: "EMI Bulanan",
      interestRate: "Kadar Faedah",
      processingFee: "Yuran Pemprosesan",
      totalInterest: "Jumlah Faedah",
      totalPayable: "Jumlah Perlu Dibayar",
      applyNow: "Mohon Sekarang",
      compareAgain: "Bandingkan Lagi",
      errorTitle: "Ralat",
      errorDesc: "Gagal mengambil tawaran pinjaman. Sila cuba lagi.",
    },

    // Testimonials Section
    testimonials: {
      badge: "Kisah Pelanggan",
      title: "Apa Kata Pelanggan Kami",
      items: [
        {
          name: "Ahmad Zaki",
          location: "Kuala Lumpur, Wilayah Persekutuan",
          car: "2018 Honda City",
          review: "Wisedrive menjadikan pembelian kereta terpakai saya bebas tekanan. Dari pemeriksaan hingga pembiayaan, segala-galanya telus.",
          services: ["Pemeriksaan", "Waranti", "Pembiayaan"],
          rating: 5,
          image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150"
        },
        {
          name: "Siti Aminah",
          location: "George Town, Pulau Pinang",
          car: "2019 Perodua Myvi",
          review: "Sebagai pembeli pertama kali, Wisedrive membimbing saya melalui semua perkara!",
          services: ["Pemeriksaan", "Waranti", "Pembiayaan"],
          rating: 4.8,
          image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150"
        },
        {
          name: "Tan Boon Hock",
          location: "Johor Bahru, Johor",
          car: "2017 Toyota Vios",
          review: "Pemeriksaan sahaja sudah berbaloi. Menyelamatkan saya daripada pembelian yang buruk!",
          services: ["Pemeriksaan", "Pembiayaan"],
          rating: 4.9,
          image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150"
        },
        {
          name: "M. Saravanan",
          location: "Ipoh, Perak",
          car: "2020 Proton X50",
          review: "Wisedrive adalah pengubah keadaan untuk pembeli kereta terpakai. Amat disyorkan!",
          services: ["Pemeriksaan", "Waranti", "Pembiayaan"],
          rating: 5,
          image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150"
        }
      ]
    },

    // FAQ Section
    faq: {
      badge: 'Ada Soalan?',
      title: 'Soalan Lazim',
      titleHighlight: 'Ditanya',
      searchPlaceholder: 'Cari jawapan...',
      categories: {
        all: 'Semua',
        inspection: 'Pemeriksaan',
        warranty: 'Waranti',
        finance: 'Pembiayaan',
      },
      stillHaveQuestions: 'Masih ada soalan?',
      cantFind: 'Tidak jumpa apa yang anda cari? Pasukan kami sedia membantu.',
      callUs: 'Hubungi Kami',
      emailUs: 'E-mel Kami',
      questions: [
        { q: 'Apa yang termasuk dalam pemeriksaan kereta?', a: 'Pemeriksaan komprehensif kami meliputi 200+ titik semakan termasuk enjin, transmisi, sistem elektrik, keadaan badan, dalaman, pengesahan dokumen (Geran, insurans, status pinjaman), dan laporan digital terperinci dengan gambar.' },
        { q: 'Berapa lama pemeriksaan mengambil masa?', a: 'Pemeriksaan di lokasi mengambil masa kira-kira 45-60 minit. Anda akan menerima laporan digital terperinci dalam 2-3 jam selepas pemeriksaan selesai.' },
        { q: 'Bolehkah saya mendapatkan pemeriksaan di lokasi saya?', a: 'Ya! Pemeriksa bertauliah kami datang ke lokasi pilihan anda - sama ada pengedar, lokasi penjual, atau rumah anda. Kami meliputi semua bandar utama di seluruh Malaysia.' },
        { q: 'Apa yang dilindungi oleh waranti Wisedrive?', a: 'Waranti kami meliputi enjin, transmisi, komponen elektrik, sistem AC, dan bahagian mekanikal. Kami mempunyai perkongsian dengan bengkel yang dibenarkan OEM di seluruh Malaysia untuk pembaikan.' },
        { q: 'Bagaimana saya memfailkan tuntutan waranti?', a: 'Cukup klik butang "Failkan Tuntutan", isikan butiran tentang masalah, dan pasukan kami akan menghubungi anda dalam 24 jam. Kami mempunyai kadar kelulusan tuntutan 98%.' },
        { q: 'Kereta mana yang layak untuk waranti?', a: 'Kereta yang lulus pemeriksaan kami dengan penilaian 3.5/5 atau lebih tinggi layak untuk pelan waranti kami. Pemeriksaan membantu menentukan kelayakan dan harga waranti.' },
        { q: 'Bolehkah saya mendapatkan pembiayaan melalui Wisedrive?', a: 'Ya! Kami bekerjasama dengan 15+ bank untuk menawarkan kadar pinjaman kereta yang kompetitif bermula dari 3.5% setahun. Bandingkan pelbagai tawaran dan dapatkan pra-kelulusan segera.' },
        { q: 'Apakah dokumen yang diperlukan untuk pinjaman kereta?', a: 'Dokumen asas termasuk MyKad, bukti alamat, bukti pendapatan (slip gaji/borang EA), dan Geran kereta. Proses 100% digital kami menjadikannya bebas masalah.' },
        { q: 'Adakah perkhidmatan tersedia di bandar saya?', a: 'Kami beroperasi di semua bandar utama di seluruh Malaysia termasuk Kuala Lumpur, Pulau Pinang, Johor Bahru, dan banyak lagi. Masukkan lokasi anda semasa menempah untuk mengesahkan ketersediaan.' },
      ],
      questionsMY: [
        { q: 'Apa yang termasuk dalam pemeriksaan kereta?', a: 'Pemeriksaan komprehensif kami meliputi 200+ titik semakan termasuk enjin, transmisi, sistem elektrik, keadaan badan, dalaman, pengesahan dokumen (Geran, insurans, status pinjaman), dan laporan digital terperinci dengan gambar.' },
        { q: 'Berapa lama pemeriksaan mengambil masa?', a: 'Pemeriksaan di lokasi mengambil masa kira-kira 45-60 minit. Anda akan menerima laporan digital terperinci dalam 2-3 jam selepas pemeriksaan selesai.' },
        { q: 'Bolehkah saya mendapatkan pemeriksaan di lokasi saya?', a: 'Ya! Pemeriksa bertauliah kami datang ke lokasi pilihan anda - sama ada pengedar, lokasi penjual, atau rumah anda. Kami meliputi semua bandar utama di seluruh Malaysia.' },
        { q: 'Apa yang dilindungi oleh waranti Wisedrive?', a: 'Waranti kami meliputi enjin, transmisi, komponen elektrik, sistem AC, dan bahagian mekanikal. Kami mempunyai perkongsian dengan bengkel yang dibenarkan OEM di seluruh Malaysia untuk pembaikan.' },
        { q: 'Bagaimana saya memfailkan tuntutan waranti?', a: 'Cukup klik butang "Failkan Tuntutan", isikan butiran tentang masalah, dan pasukan kami akan menghubungi anda dalam 24 jam. Kami mempunyai kadar kelulusan tuntutan 98%.' },
        { q: 'Kereta mana yang layak untuk waranti?', a: 'Kereta yang lulus pemeriksaan kami dengan penilaian 3.5/5 atau lebih tinggi layak untuk pelan waranti kami. Pemeriksaan membantu menentukan kelayakan dan harga waranti.' },
        { q: 'Bolehkah saya mendapatkan pembiayaan melalui Wisedrive?', a: 'Ya! Kami bekerjasama dengan 15+ bank untuk menawarkan kadar pinjaman kereta yang kompetitif bermula dari 3.5% setahun. Bandingkan pelbagai tawaran dan dapatkan pra-kelulusan segera.' },
        { q: 'Apakah dokumen yang diperlukan untuk pinjaman kereta?', a: 'Dokumen asas termasuk MyKad, bukti alamat, bukti pendapatan (slip gaji/borang EA), dan Geran kereta. Proses 100% digital kami menjadikannya bebas masalah.' },
        { q: 'Adakah perkhidmatan tersedia di bandar saya?', a: 'Kami beroperasi di semua bandar utama di seluruh Malaysia termasuk Kuala Lumpur, Pulau Pinang, Johor Bahru, dan banyak lagi. Masukkan lokasi anda semasa menempah untuk mengesahkan ketersediaan.' },
      ],
    },

    // Footer
    footer: {
      tagline: 'Menjadikan pembelian kereta terpakai selamat & telus.',
      company: 'Syarikat',
      about: 'Tentang Kami',
      careers: 'Kerjaya',
      press: 'Akhbar',
      contact: 'Hubungi',
      services: 'Perkhidmatan',
      inspection: 'Pemeriksaan Kereta',
      warranty: 'Waranti Lanjutan',
      financing: 'Pembiayaan Kereta',
      forBusiness: 'Untuk Perniagaan',
      support: 'Sokongan',
      helpCenter: 'Pusat Bantuan',
      terms: 'Terma Perkhidmatan',
      privacy: 'Dasar Privasi',
      refund: 'Dasar Bayaran Balik',
      copyright: 'Hak cipta terpelihara.',
    },

    // Legal Pages
    legal: {
      backToHome: 'Kembali ke Laman Utama',
      lastUpdated: 'Dikemas Kini',
      effectiveDate: 'Tarikh Berkuat Kuasa',
      contactUs: 'Hubungi Kami',
      privacy: {
        title: 'Dasar Privasi',
        subtitle: 'Bagaimana kami mengumpul, menggunakan, dan melindungi maklumat peribadi anda.',
      },
      terms: {
        title: 'Terma Perkhidmatan',
        subtitle: 'Terma dan syarat yang mengawal penggunaan perkhidmatan pemeriksaan Wisedrive.',
        general: 'Am',
        exclusions: 'Pengecualian',
        exclusionsSubtitle: 'Perkara yang Tidak Kami Periksa:',
        inspectionCannot: 'Tambahan pula, Pemeriksaan tidak boleh:',
        roadTesting: 'Ujian Jalan Raya',
        feesAndCancellations: 'Yuran dan Pembatalan',
        complaints: 'Aduan',
        outsideControl: 'Perkara Di Luar Kawalan Kami',
        enforcement: 'Penguatkuasaan Terma',
        reportAdvice: 'Nasihat Laporan',
      },
      refund: {
        titleIN: 'Dasar Pembatalan dan Bayaran Balik',
        titleMY: 'Dasar Pembatalan & Bayaran Balik',
        subtitle: 'Polisi kami untuk pembatalan dan bayaran balik.',
      },
    },

    // Common
    common: {
      loading: 'Memuatkan...',
      error: 'Ralat',
      success: 'Berjaya',
      cancel: 'Batal',
      save: 'Simpan',
      edit: 'Edit',
      delete: 'Padam',
      confirm: 'Sahkan',
      yes: 'Ya',
      no: 'Tidak',
      ok: 'OK',
      free: 'PERCUMA',
      otpSent: 'OTP Dihantar!',
      otpSentDesc: 'OTP dihantar ke {phone}',
      invalidOtp: 'OTP Tidak Sah',
      verified: 'Disahkan!',
      verifiedDesc: 'Nombor telefon berjaya disahkan',
      errorPhone: 'Sila masukkan nama dan nombor telefon yang sah',
    },

    // Cities (for scheduling) - Malaysian cities
    cities: {
      kualaLumpur: 'Kuala Lumpur',
      penang: 'Pulau Pinang',
      johorBahru: 'Johor Bahru',
      ipoh: 'Ipoh',
      melaka: 'Melaka',
      kotaKinabalu: 'Kota Kinabalu',
      kuching: 'Kuching',
      shahAlam: 'Shah Alam',
    },

    // Business Page
    business: {
      heroSubtitle: 'Penyelesaian Enterprise',
      heroTitle: 'Pemeriksaan Kenderaan Dikuasakan AI untuk',
      heroTitleHighlight: 'Rakan Enterprise',
      heroDesc: 'Bank, syarikat insurans, dan platform lelongan mempercayai Wisedrive untuk pemeriksaan pra-pembayaran, pengunderaitan, dan penilaian aset. AI + pemeriksa terlatih kami memberikan laporan standard, sedia audit.',
      requestDemo: 'Minta Demo',
      viewCapabilities: 'Lihat Keupayaan',
      trustedBy: 'Dipercayai oleh Enterprise Terkemuka',

      // Use Cases
      useCasesTitle: 'Penyelesaian Khusus untuk Industri Anda',
      useCasesDesc: 'Pilih industri anda untuk melihat bagaimana Wisedrive membantu',

      banks: {
        title: 'Bank & NBFC',
        subtitle: 'Pemeriksaan Pra-Pembayaran',
        desc: 'Bank boleh menggunakan Wisedrive untuk memeriksa kereta terpakai sebelum meluluskan pinjaman. AI + pemeriksa terlatih kami menilai keadaan mekanikal, sejarah kemalangan, isyarat penipuan, dan risiko penilaian.',
        output: 'Laporan pemeriksaan standard + skor risiko + keyakinan penilaian',
        benefits: {
          faster: { title: 'Kelulusan Pinjaman Lebih Pantas', desc: 'Kurangkan TAT dari hari ke jam dengan laporan berkuasa AI segera' },
          npa: { title: 'Risiko NPA Lebih Rendah', desc: 'Kenal pasti kenderaan berisiko tinggi sebelum pembayaran' },
          valuation: { title: 'Penilaian Cagaran Lebih Baik', desc: 'Anggaran nilai pasaran dipacu AI dengan skor keyakinan' },
          fraud: { title: 'Penipuan Dikurangkan', desc: 'Kesan pengubahan odometer, sejarah kemalangan & penipuan dokumen' },
        },
        stats: { npa: 'Pengurangan NPA', time: 'Purata Masa Laporan', fraud: 'Pengesanan Penipuan' },
      },

      insurance: {
        title: 'Syarikat Insurans',
        subtitle: 'Pengunderaitan & Pemeriksaan Tuntutan',
        desc: 'Digunakan semasa mengeluarkan insurans untuk polisi tamat tempoh dan pemeriksaan pasca-kemalangan. AI kami mengesan kerosakan dan menganggarkan kos pembaikan dengan lebih tepat dan telus.',
        output: 'Laporan penilaian kerosakan + anggaran kos pembaikan + jejak audit',
        benefits: {
          faster: { title: 'Penyelesaian Tuntutan Lebih Pantas', desc: 'Kurangkan masa pemprosesan tuntutan sebanyak 60% dengan penilaian segera' },
          disputes: { title: 'Pertikaian Dikurangkan', desc: 'Laporan kerosakan objektif, disahkan AI meminimumkan konflik' },
          estimation: { title: 'Anggaran Pembaikan Objektif', desc: 'Anggaran kos pembaikan berkaitan pasaran dengan bukti foto' },
          audit: { title: 'Laporan Sedia Audit', desc: 'Dokumentasi lengkap untuk pematuhan peraturan' },
        },
        stats: { claims: 'Tuntutan Lebih Pantas', savings: 'Penjimatan Kos', audit: 'Patuh Audit' },
      },

      auction: {
        title: 'Platform Lelongan & Repo',
        subtitle: 'Kesihatan & Penetapan Harga Aset',
        desc: 'Nilai kereta repo sebelum lelongan. Pemeriksaan kami memberikan keyakinan pembeli, mengurangkan pertikaian, dan membantu menetapkan harga rizab yang tepat berdasarkan keadaan sebenar.',
        output: 'Laporan keadaan + nilai pasaran saksama + skor kesediaan lelongan',
        benefits: {
          pricing: { title: 'Penetapan Harga Tepat', desc: 'Tetapkan harga rizab realistik berdasarkan keadaan kenderaan sebenar' },
          disputes: { title: 'Pertikaian Lebih Sedikit', desc: 'Laporan keadaan telus mengurangkan aduan pembeli' },
          decisions: { title: 'Keputusan Bermaklumat', desc: 'Laporan komprehensif membantu pembida membuat tawaran yakin' },
          turnaround: { title: 'Pusingan Pantas', desc: 'Pemeriksaan hari sama memastikan inventori anda bergerak' },
        },
        stats: { pricing: 'Ketepatan Harga', disputes: 'Pertikaian Lebih Sedikit', clearance: 'Pelepasan Inventori' },
      },

      // Trust Section
      trustTitle: 'Ketepatan AI Yang Boleh Dipercayai',
      trustDesc: 'Model AI kami dilatih dengan 100,000+ pemeriksaan sebenar, memberikan ketepatan tiada tandingan',
      trustStats: {
        fraud: { value: '99.7%', label: 'Kadar Pengesanan Penipuan', desc: 'Menangkap pengubahan odometer, sejarah kemalangan, penipuan dokumen' },
        damage: { value: '97.3%', label: 'Pengesanan Kerosakan', desc: 'Penglihatan komputer mengenal pasti pembaikan tidak kelihatan pada mata kasar' },
        valuation: { value: '±3%', label: 'Ketepatan Penilaian', desc: 'Penetapan harga berkaitan pasaran dengan selang keyakinan' },
        false: { value: '<0.1%', label: 'Kadar Positif Palsu', desc: 'Meminimumkan penolakan pinjaman yang tidak perlu' },
      },

      // Technology Section
      techTitle: 'Dikuasakan oleh Teknologi Canggih',
      techDesc: 'Infrastruktur AI gred enterprise untuk pemeriksaan yang boleh dipercayai dan berskala',
      techItems: {
        vision: { title: 'AI Penglihatan Komputer', desc: 'Menganalisis 500+ parameter visual setiap kenderaan', feature: 'Mengesan kerja cat, penggantian panel, kerosakan struktur' },
        obd: { title: 'Imbasan Mendalam OBD-II', desc: 'Membaca 76+ parameter ECU untuk diagnostik komprehensif', feature: 'Pengesanan kerosakan enjin, transmisi, ABS, beg udara' },
        valuation: { title: 'Enjin Penilaian ML', desc: 'Integrasi data pasaran masa nyata', feature: 'Model susut nilai, harga serantau, isyarat permintaan' },
      },

      // Transparency Section
      transparencyTitle: 'Ketelusan Lengkap & Jejak Audit',
      transparencyDesc: 'Setiap pemeriksaan didokumenkan dengan bukti bertanda masa untuk pematuhan peraturan',
      transparencyItems: {
        timestamp: { title: 'Bukti Bertanda Masa', desc: 'Setiap foto dan titik data bertanda GPS & masa' },
        inspector: { title: 'Pengesahan Pemeriksa', desc: 'Pemeriksa bertauliah dengan pengesahan identiti' },
        tamperProof: { title: 'Laporan Kalis Ubah', desc: 'Keaslian laporan disokong blockchain' },
      },

      // Demo Form
      demoTitle: 'Minta Demo',
      demoDesc: 'Lihat bagaimana Wisedrive boleh mengubah proses penilaian kenderaan anda',
      demoForm: {
        company: 'Nama Syarikat',
        name: 'Nama Anda',
        email: 'E-mel Kerja',
        phone: 'Telefon',
        industry: 'Industri',
        selectIndustry: 'Pilih Industri',
        volume: 'Jumlah Bulanan',
        selectVolume: 'Pilih Jumlah',
        submit: 'Minta Demo',
        submitting: 'Menghantar...',
      },
      demoSuccess: 'Demo Diminta',
      demoSuccessDesc: 'Terima kasih atas minat anda terhadap Wisedrive. Pasukan kami akan menghubungi anda tidak lama lagi untuk menjadualkan demo anda.',

      // Contact
      contactTitle: 'Soalan?',
      contactDesc: 'Pasukan enterprise kami sedia membantu',
      salesEmail: 'support.my@wisedrive.com',
      salesPhone: '+60 122559610',

      backToHome: 'Kembali ke Laman Utama',
    },
    businessPage: {
      nav: {
        consumer: 'Pengguna',
        useCases: 'Kes Penggunaan',
        features: 'Ciri-ciri',
        howItWorks: 'Cara Ia Berfungsi',
      },
      hero: {
        viewCapabilities: 'Lihat Keupayaan',
      },
      stats: {
        citiesCovered: 'Bandar Diliputi',
        inspectionsDone: 'Pemeriksaan Selesai',
        enterpriseClients: 'Pelanggan Enterprise',
        aiAccuracy: 'Ketepatan AI',
      },
      benefits: {
        title: 'Manfaat Utama',
      },
      output: 'OUTPUT',
      features: {
        title: 'Apa Yang Enterprise Dapat',
        subtitle: 'Infrastruktur pemeriksaan komprehensif yang dibina untuk skala',
        report: { title: 'Laporan Pemeriksaan Berkuasa AI', desc: 'Penilaian terperinci 200+ titik dengan gambar' },
        damage: { title: 'Pengesanan Kerosakan & Anggaran Pembaikan', desc: 'Penglihatan komputer mengenal pasti semua kecacatan' },
        valuation: { title: 'Skor Keadaan & Penilaian', desc: 'Penetapan harga berkaitan pasaran dengan tahap keyakinan' },
        fraud: { title: 'Pengesanan Penipuan & Manipulasi', desc: 'Pengesahan odometer, kemalangan & dokumen' },
        coverage: {
          titleIndia: 'Liputan Lapangan Seluruh India',
          titleMY: 'Liputan Seluruh Negara',
          descIndia: '500+ bandar dengan rangkaian pemeriksa terlatih',
          descMY: 'Semua bandar utama dengan rangkaian pemeriksa terlatih',
        },
        api: { title: 'Integrasi Dashboard & API', desc: 'API RESTful untuk integrasi sistem yang lancar' },
      },
      trust: {
        badge: 'Ketepatan Peneraju Industri',
        descriptionFull: 'Model AI kami dilatih dengan 1,00,000+ pemeriksaan sebenar dan divalidasi secara berterusan terhadap data kebenaran asas',
      },
      tech: {
        visionDesc: 'Model pembelajaran mendalam menganalisis 500+ parameter visual untuk mengesan ketidakkonsistenan cat, jurang panel, dan pembaikan tersembunyi',
        obdDesc: 'Komunikasi ECU secara langsung membaca 76+ parameter termasuk kod ralat tersembunyi, sejarah servis, dan pengesahan perbatuan',
        valuationDesc: 'Data pasaran masa nyata + skor keadaan = penilaian tepat dengan selang keyakinan',
      },
      transparency: {
        badge: '100% Telus',
        regulatory: {
          title: 'Pematuhan Kawal Selia',
          desc: 'Laporan direka untuk mematuhi piawaian kawal selia dan audit tempatan',
        },
      },
      reportPreview: {
        sampleReport: 'Laporan Contoh Enterprise',
        inspectionReport: 'Laporan Pemeriksaan',
        verified: 'Disahkan',
        reportId: 'ID Laporan',
        vehicle: 'Kenderaan',
        conditionScore: 'Skor Keadaan',
        riskFlag: 'Bendera Risiko',
        none: 'Tiada',
        auditTrail: 'JEJAK AUDIT',
        started: 'Pemeriksaan Bermula',
        photos: 'Gambar Diambil (45)',
        obdComplete: 'Imbasan OBD Selesai',
        aiDone: 'Analisis AI Selesai',
        generated: 'Laporan Dijana',
        digitallySigned: 'Ditandatangani Secara Digital',
      },
      network: {
        titleIndia: 'Rangkaian Pemeriksa Seluruh India',
        titleMY: 'Rangkaian Pemeriksa Seluruh Negara',
        subtitle: 'Pakar bertauliah memberikan kualiti konsisten di {count} bandar',
        stats: {
          inspectors: 'Pemeriksa Bertauliah',
          cities: 'Bandar Diliputi',
          rating: 'Purata Penilaian Pemeriksa',
          tat: 'Purata Masa Pusingan',
        },
        process: {
          title: 'Proses Pensijilan Pemeriksa',
          steps: [
            { title: 'Permohonan', desc: 'Semakan latar belakang & pengesahan dokumen' },
            { title: 'Latihan', desc: 'Program latihan teknikal 40 jam' },
            { title: 'Pensijilan', desc: 'Penilaian bertulis & praktikal' },
            { title: 'Onboarding', desc: 'Kit alatan & latihan aplikasi' },
            { title: 'QA Berterusan', desc: 'Audit tetap & pensijilan semula' },
          ]
        }
      },
      api: {
        badge: 'Mesra Pembangun',
        title: 'Integrasi API Yang Lancar',
        desc: "Integrasikan infrastruktur pemeriksaan Wisedrive secara langsung ke dalam sistem sedia ada anda dengan API RESTful dan webhook kami.",
        features: [
          'API RESTful dengan dokumentasi komprehensif',
          'Pemberitahuan webhook masa nyata',
          'Persekitaran Sandbox untuk ujian',
          'Sokongan integrasi khusus',
          'Infrastruktur patuh SOC 2',
        ],
        viewDocs: 'Lihat Dokumen API',
      },
      howItWorks: {
        title: 'Cara Ia Berfungsi',
        subtitle: 'Proses mudah 5 langkah daripada permohonan ke penghantaran laporan',
        steps: [
          { title: 'Mohon Pemeriksaan', desc: 'Syarikat menghantar permohonan pemeriksaan melalui papan pemuka atau API' },
          { title: 'Tugasan Pemeriksa', desc: 'Wisedrive menetapkan pemeriksa bertauliah yang terdekat' },
          { title: 'Pemeriksaan Di Lokasi', desc: 'Kenderaan diperiksa dengan alatan diagnostik berkuasa AI' },
          { title: 'Analisis AI', desc: 'AI menjana laporan, penilaian & amaran risiko' },
          { title: 'Penghantaran Laporan', desc: 'Syarikat mengakses laporan melalui papan pemuka atau API' },
        ],
      },
      cta: {
        title: 'Bina Keputusan Pembiayaan Auto Yang Lebih Pantas & Selamat dengan Wisedrive',
        subtitle: 'Sertai 50+ institusi kewangan yang telah menggunakan infrastruktur pemeriksaan kami',
        contact: 'Hubungi Rakan Kerjasama',
      },
      footer: {
        tagline: 'Infrastruktur Pemeriksaan Kenderaan Enterprise',
      },
    },

    // Sample Report Page
    sampleReport: {
      // Header
      reportOptions: 'Pilihan Laporan',
      shareWhatsApp: 'Kongsi via WhatsApp',
      printReport: 'Cetak Laporan',
      report: 'Laporan',

      // HeroSection
      points: 'Mata',
      owners: 'Pemilik',
      overallRating: 'Penilaian Keseluruhan',
      recommended: 'Disyorkan',
      notRecommended: 'Tidak Disyorkan',
      goodCondition: 'Keadaan baik untuk dibeli',
      requiresRepairs: 'Memerlukan pembaikan yang ketara',
      customer: 'Pelanggan',
      location: 'Lokasi',
      inspectedOn: 'Diperiksa Pada',
      inspector: 'Pemeriksa',
      marketValue: 'Nilai Pasaran Disyorkan',
      evaluationPending: 'Penilaian Belum Selesai',

      // AssessmentSummary
      assessmentSummary: 'Ringkasan Penilaian',
      keyFindings: 'Penemuan Utama',

      // VehicleDetails
      vehicleDetails: 'Maklumat Kenderaan',
      make: 'Jenama',
      model: 'Model',
      year: 'Tahun',
      fuel: 'Bahan Api',
      transmissionLabel: 'Transmisi',
      mfgDate: 'Tarikh Pembuatan',
      regNumber: 'Nombor Pendaftaran',
      regDate: 'Tarikh Pendaftaran',
      colour: 'Warna',
      engineCC: 'Kubik Enjin',
      engineNo: 'Nombor Enjin',
      chassisNo: 'Nombor Casis',
      showMore: 'Tunjukkan lebih banyak butiran...',

      // KeyInfo
      keyInformation: 'Maklumat Utama',
      kmsDriven: 'KM Dipandu',
      engine: 'Enjin',
      interior: 'Dalaman',
      exterior: 'Eksterior',
      insurance: 'Insurans',
      accident: 'Kemalangan',
      floodDamage: 'Kerosakan Banjir',
      tyreLife: 'Hayat Tayar',
      minorRepairs: 'Pembaikan Kecil',
      majorRepairs: 'Pembaikan Besar',

      // Status labels
      statusGood: 'Baik',
      statusAverage: 'Sederhana',
      statusPoor: 'Buruk',
      statusExpired: 'Tamat Tempoh',
      statusYes: 'Ya',
      statusNo: 'Tidak',

      // RTO Verification
      rtoVerification: 'Pengesahan RTO',
      allClear: 'Semua Bersih',
      actionNeeded: 'Tindakan Diperlukan',
      trafficChallans: 'Saman Trafik',
      hypothecation: 'Hipoteket',
      blacklist: 'Senarai Hitam',
      bankNOC: 'NOC Bank',
      financier: 'Pembiaya',

      // OBD
      obdDiagnostics: 'Diagnostik OBD-2',
      errors: 'Ralat',
      error: 'Ralat',
      criticalIssues: '{count} isu kritikal memerlukan perhatian segera',
      possibleCauses: 'Kemungkinan Punca',
      symptoms: 'Gejala',
      solutions: 'Penyelesaian',
      critical: 'Kritikal',
      warning: 'Amaran',
      noDiagnosticErrors: 'Tiada Ralat Diagnostik',
      allSystemsNormal: 'Semua sistem berfungsi dengan normal',

      // Inspection Details
      inspectionDetails: 'Butiran Pemeriksaan',
      checkpoints: 'Titik Semak',
      categories: 'Kategori',
      swipeToSee: '← Leret untuk lihat lebih banyak titik semak →',
      question: 'Soalan',
      answer: 'Jawapan',
      instruction: 'Arahan',
      followUp: 'Susulan',
      photo: 'Foto',
      pts: 'mata',

      // Footer
      inspectWise: 'Periksa Bijak, Pandu Cerdas - Perkhidmatan pemeriksaan kenderaan profesional dengan laporan komprehensif.',
      reportFeatures: 'Ciri Laporan',
      methodsUsed: 'Kaedah Digunakan',
      easyToRead: 'Mudah Dibaca',
      easyToTrack: 'Mudah Dipantau',
      comprehensive: 'Komprehensif',
      physicalInspection: 'Pemeriksaan Fizikal',
      aiAnalysis: 'Analisis AI',
      obd2Scanning: 'Pengimbasan OBD2',
      features: 'Ciri',
      methods: 'Kaedah',
      published: 'Diterbitkan',

      // Modals
      inspectionVideo: 'Video Pemeriksaan',
      inspectionPhoto: 'Foto Pemeriksaan',
      duration: 'Tempoh',
      close: 'Tutup',
      insuranceDetails: 'Butiran Insurans',
      insurerName: 'Nama Penanggung Insurans',
      policyNumber: 'Nombor Polisi',
      policyType: 'Jenis Polisi',
      expiryDate: 'Tarikh Tamat Tempoh',
      idvValue: 'Nilai IDV',
      status: 'Status',
      tyreConditionDetails: 'Butiran Keadaan Tayar',
      averageTyreLife: 'Purata Hayat Tayar',
      treadLife: 'Hayat Alur',
      brand: 'Jenama',
      totalMinorRepairs: 'Jumlah Pembaikan Kecil',
      totalMajorRepairs: 'Jumlah Pembaikan Besar',
      minor: 'Kecil',
      major: 'Besar',
      sparePart: 'Alat Ganti',
      labor: 'Buruh',
    },
  },
};

export default translations;
